
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("2z79p", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $e06c93de1af7917c$export$dae496af0944fc08 = (0, $eSUdr.default)`query AudienceSegmentationContextProviderQuery($accountId:ID){user:confluence_atlassianUser(id:$accountId){id confluence{groupsWithId{id}}}}`;
module.exports["AudienceSegmentationContextProviderQuery"] = $e06c93de1af7917c$export$dae496af0944fc08;

});

parcelRegister("drwOC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $awHlv = parcelRequire("awHlv");


var $fm19L = parcelRequire("fm19L");





var $gtauf = parcelRequire("gtauf");

const $80be7cdfacfd55be$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $80be7cdfacfd55be$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $80be7cdfacfd55be$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $80be7cdfacfd55be$var$GET_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET';
const $80be7cdfacfd55be$var$CREATE_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_CREATE';
const $80be7cdfacfd55be$var$UPDATE_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE';
const $80be7cdfacfd55be$var$DELETE_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_DELETE';
/**
 * Query to get the page property by key
 * @param documentARI
 * @param key
 * @returns
 */ const $80be7cdfacfd55be$var$GET_PAGE_QUERY = `query ${$80be7cdfacfd55be$var$GET_OPERATION_NAME} ($id: ID!, $keys: [String]!) {
					confluence {
						page (id: $id) {
							properties(keys: $keys) {
								key,
								value
							}
						}
					}
				}`;
/**
 * Query to get the blog page property by key
 * @param documentARI
 * @param key
 * @returns
 */ const $80be7cdfacfd55be$var$GET_BLOG_QUERY = `query ${$80be7cdfacfd55be$var$GET_OPERATION_NAME} ($id: ID!, $keys: [String]!) {
	confluence {
		blogPost (id: $id) {
			properties(keys: $keys) {
				key,
				value
			}
		}
	}
}`;
/**
 * Query to create a page property with key and value
 * @param documentARI
 * @param key
 * @param value
 * @returns
 */ const $80be7cdfacfd55be$var$CREATE_PAGE_QUERY = `mutation ${$80be7cdfacfd55be$var$CREATE_OPERATION_NAME} ($input: ConfluenceCreatePagePropertyInput!){
						confluence {
							createPageProperty(input: $input) {
								pageProperty {
									key,
									value
								}
							}
						}
					}`;
/**
 * Query to create a blog page property with key and value
 * @param documentARI
 * @param key
 * @param value
 * @returns
 */ const $80be7cdfacfd55be$var$CREATE_BLOG_QUERY = `mutation ${$80be7cdfacfd55be$var$CREATE_OPERATION_NAME} ($input: ConfluenceCreateBlogPostPropertyInput!){
	confluence {
		createBlogPostProperty(input: $input) {
			blogPostProperty {
				key,
				value
			}
		}
	}
}`;
/**
 * Query to update a page property with key and value without bumping the version
 * @param documentARI
 * @param key
 * @param value
 * @returns
 */ const $80be7cdfacfd55be$var$UPDATE_PAGE_QUERY = `mutation ${$80be7cdfacfd55be$var$UPDATE_OPERATION_NAME} ($input: ConfluenceUpdateValuePagePropertyInput!) {
						confluence {
							updateValuePageProperty(input: $input) {
								pageProperty {
									key,
									value
								}
							}
						}
					}`;
/**
 * Query to update a blog page property with key and value without bumping the version
 * @param documentARI
 * @param key
 * @param value
 * @returns
 */ const $80be7cdfacfd55be$var$UPDATE_BLOG_QUERY = `mutation ${$80be7cdfacfd55be$var$UPDATE_OPERATION_NAME} ($input: ConfluenceUpdateValueBlogPostPropertyInput!) {
	confluence {
		updateValueBlogPostProperty(input: $input) {
			blogPostProperty {
				key,
				value
			}
		}
	}
}`;
const $80be7cdfacfd55be$var$DELETE_PAGE_QUERY = `mutation ${$80be7cdfacfd55be$var$DELETE_OPERATION_NAME} ($input: ConfluenceDeletePagePropertyInput!) {
						confluence {
							deletePageProperty(input: $input) {
								success, errors {
								  message
								}
							}
						}
					}`;
const $80be7cdfacfd55be$var$DELETE_BLOG_QUERY = `mutation ${$80be7cdfacfd55be$var$DELETE_OPERATION_NAME} ($input: ConfluenceDeleteBlogPostPropertyInput!) {
						confluence {
							deleteBlogPostProperty(input: $input) {
								success, errors {
								  message
								}
							}
						}
					}`;
const $80be7cdfacfd55be$export$bb67e141aff8cd41 = async ({ pageId: pageId, key: key, cloudId: cloudId, pageType: pageType })=>{
    const documentARI = (0, $fm19L.getConfluencePageAri)(pageId, cloudId, pageType);
    const isBlog = (0, $gtauf.isBlogPageType)(pageType);
    const bodyData = {
        query: isBlog ? $80be7cdfacfd55be$var$GET_BLOG_QUERY : $80be7cdfacfd55be$var$GET_PAGE_QUERY,
        operationName: $80be7cdfacfd55be$var$GET_OPERATION_NAME,
        variables: {
            id: documentARI,
            keys: [
                key
            ]
        }
    };
    const response = await fetch($80be7cdfacfd55be$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$80be7cdfacfd55be$var$COMMON_HEADERS,
            ...$80be7cdfacfd55be$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get content property: ${response.statusText}`);
    return await response.json();
};
const $80be7cdfacfd55be$export$392f5cb0a0c7397a = async ({ pageId: pageId, key: key, value: value, cloudId: cloudId, pageType: pageType })=>{
    const documentARI = (0, $fm19L.getConfluencePageAri)(pageId, cloudId, pageType);
    const isBlog = (0, $gtauf.isBlogPageType)(pageType);
    const useSameVersion = {
        useSameVersion: true
    };
    let input = {
        ...isBlog ? {
            blogPostId: documentARI
        } : {
            pageId: documentARI
        },
        key: key,
        value: JSON.stringify({
            content: value.content
        })
    };
    // Blog content properties don't support the useSameVersion flag at the moment
    if (!isBlog) input = {
        ...input,
        ...useSameVersion
    };
    const bodyData = {
        query: isBlog ? $80be7cdfacfd55be$var$UPDATE_BLOG_QUERY : $80be7cdfacfd55be$var$UPDATE_PAGE_QUERY,
        operationName: $80be7cdfacfd55be$var$UPDATE_OPERATION_NAME,
        variables: {
            input: input
        }
    };
    const response = await fetch($80be7cdfacfd55be$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$80be7cdfacfd55be$var$COMMON_HEADERS,
            ...$80be7cdfacfd55be$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to update content property: ${response.statusText}`);
    return await response.json();
};
const $80be7cdfacfd55be$export$548a7902545a91c0 = async ({ pageId: pageId, key: key, value: value, cloudId: cloudId, pageType: pageType })=>{
    const documentARI = (0, $fm19L.getConfluencePageAri)(pageId, cloudId, pageType);
    const isBlog = (0, $gtauf.isBlogPageType)(pageType);
    const bodyData = {
        query: isBlog ? $80be7cdfacfd55be$var$CREATE_BLOG_QUERY : $80be7cdfacfd55be$var$CREATE_PAGE_QUERY,
        operationName: $80be7cdfacfd55be$var$CREATE_OPERATION_NAME,
        variables: {
            input: {
                ...isBlog ? {
                    blogPostId: documentARI
                } : {
                    pageId: documentARI
                },
                key: key,
                value: JSON.stringify({
                    content: value.content
                })
            }
        }
    };
    const response = await fetch($80be7cdfacfd55be$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$80be7cdfacfd55be$var$COMMON_HEADERS,
            ...$80be7cdfacfd55be$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to create content property: ${response.statusText}`);
    return await response.json();
};
const $80be7cdfacfd55be$export$6b825d9de9c1c1cb = async ({ pageId: pageId, cloudId: cloudId, pageType: pageType, key: key })=>{
    const documentARI = (0, $fm19L.getConfluencePageAri)(pageId, cloudId, pageType);
    const isBlog = (0, $gtauf.isBlogPageType)(pageType);
    const bodyData = {
        query: isBlog ? $80be7cdfacfd55be$var$DELETE_BLOG_QUERY : $80be7cdfacfd55be$var$DELETE_PAGE_QUERY,
        operationName: $80be7cdfacfd55be$var$DELETE_OPERATION_NAME,
        variables: {
            input: {
                ...isBlog ? {
                    blogPostId: documentARI
                } : {
                    pageId: documentARI
                },
                key: key
            }
        }
    };
    const response = await fetch($80be7cdfacfd55be$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$80be7cdfacfd55be$var$COMMON_HEADERS,
            ...$80be7cdfacfd55be$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to delete content property: ${response.statusText}`);
    return await response.json();
};


const $22be2fac1f3375a4$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};





const $3f24c0cbcf37c5cb$var$getContentPropertyKey = (contentPropertyKey, localId)=>{
    return contentPropertyKey + '-' + localId;
};
const $3f24c0cbcf37c5cb$var$parseSyncedBlockContentPropertyValue = (value)=>{
    try {
        if (value !== '') {
            const parsedValue = JSON.parse(value);
            if (typeof parsedValue.content === 'object') return parsedValue;
            throw new Error('Cannot parse synced block data: required properties missing in value');
        } else throw new Error('Cannot parse synced block data: value is empty');
    } catch (error) {
        throw new Error(`Failed to parse synced block data: ${error}`);
    }
};
const $3f24c0cbcf37c5cb$var$getResponseError = (contentProperty)=>{
    const content = 'blogPost' in contentProperty.data.confluence ? contentProperty.data.confluence.blogPost : contentProperty.data.confluence.page;
    if (!content) return (0, $awHlv.SyncBlockError).Forbidden;
    if (!content.properties?.[0]) return (0, $awHlv.SyncBlockError).NotFound;
    return (0, $awHlv.SyncBlockError).Errored;
};
/**
 * ADFFetchProvider implementation that fetches synced block data from Confluence Content API
 */ class $3f24c0cbcf37c5cb$var$ConfluenceADFFetchProvider {
    async fetchData(resourceId) {
        const { id: pageId, type: pageType } = (0, $fm19L.getPageIdAndTypeFromAri)(resourceId);
        const localId = (0, $fm19L.getLocalIdFromAri)(resourceId);
        try {
            const key = $3f24c0cbcf37c5cb$var$getContentPropertyKey(this.config.contentPropertyKey, localId);
            const options = {
                pageId: pageId,
                key: key,
                cloudId: this.config.cloudId,
                pageType: pageType
            };
            let error;
            let value;
            if ((0, $gtauf.isBlogPageType)(pageType)) {
                const contentProperty = await (0, $80be7cdfacfd55be$export$bb67e141aff8cd41)(options);
                value = contentProperty.data.confluence.blogPost?.properties?.[0]?.value;
                error = $3f24c0cbcf37c5cb$var$getResponseError(contentProperty);
            } else {
                const contentProperty = await (0, $80be7cdfacfd55be$export$bb67e141aff8cd41)(options);
                value = contentProperty.data.confluence.page?.properties?.[0]?.value;
                error = $3f24c0cbcf37c5cb$var$getResponseError(contentProperty);
            }
            if (!value) return {
                error: error,
                resourceId: resourceId
            };
            // Parse the synced block content from the property value
            const syncedBlockData = $3f24c0cbcf37c5cb$var$parseSyncedBlockContentPropertyValue(value);
            return {
                data: {
                    content: syncedBlockData.content,
                    resourceId: resourceId,
                    blockInstanceId: localId
                },
                resourceId: resourceId
            };
        } catch  {
            return {
                error: (0, $awHlv.SyncBlockError).Errored,
                resourceId: resourceId
            };
        }
    }
    constructor(config){
        this.config = config;
    }
}
/**
 * ADFWriteProvider implementation that writes synced block data to Confluence Content API
 */ class $3f24c0cbcf37c5cb$var$ConfluenceADFWriteProvider {
    async writeData(data) {
        let match;
        const { resourceId: resourceId } = data;
        try {
            match = (0, $fm19L.getPageIdAndTypeFromAri)(data.resourceId);
        } catch (error) {
            return {
                error: (0, $22be2fac1f3375a4$export$7fc2c997455452c8)(error)
            };
        }
        const { id: pageId, type: pageType } = match;
        try {
            // Update existing content property
            const localId = (0, $fm19L.getLocalIdFromAri)(resourceId);
            const key = $3f24c0cbcf37c5cb$var$getContentPropertyKey(this.config.contentPropertyKey, localId);
            const options = {
                pageId: pageId,
                key: key,
                value: data,
                cloudId: this.config.cloudId,
                pageType: pageType
            };
            const updatePayload = await (0, $80be7cdfacfd55be$export$392f5cb0a0c7397a)(options);
            const updateResult = (0, $gtauf.isBlogPageType)(pageType) ? updatePayload.data.confluence.updateValueBlogPostProperty.blogPostProperty : updatePayload.data.confluence.updateValuePageProperty.pageProperty;
            if (updateResult?.key === key) return {
                resourceId: resourceId
            };
            else if (!updateResult) return this.createNewContentProperty(pageId, key, data, pageType).then(()=>{
                return {
                    resourceId: resourceId
                };
            }, (error)=>{
                return {
                    error: error
                };
            });
            else return {
                error: `Failed to update ${pageType} content property`
            };
        } catch  {
            return {
                error: `Failed to write ${pageType}`
            };
        }
    }
    async deleteData(resourceId) {
        let deletePayload, deleteResult, match;
        try {
            match = (0, $fm19L.getPageIdAndTypeFromAri)(resourceId);
        } catch (error) {
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $22be2fac1f3375a4$export$7fc2c997455452c8)(error)
            };
        }
        const { id: pageId, type: pageType } = match;
        try {
            const localId = (0, $fm19L.getLocalIdFromAri)(resourceId);
            const key = $3f24c0cbcf37c5cb$var$getContentPropertyKey(this.config.contentPropertyKey, localId);
            const options = {
                pageId: pageId,
                key: key,
                cloudId: this.config.cloudId,
                pageType: pageType
            };
            deletePayload = await (0, $80be7cdfacfd55be$export$6b825d9de9c1c1cb)(options);
            deleteResult = (0, $gtauf.isBlogPageType)(pageType) ? deletePayload.data.confluence.deleteBlogPostProperty : deletePayload.data.confluence.deletePageProperty;
        } catch (error) {
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $22be2fac1f3375a4$export$7fc2c997455452c8)(error) ?? `Fail to delete ${pageType} content property`
            };
        }
        return {
            resourceId: resourceId,
            success: deleteResult.success,
            error: deleteResult.errors.join()
        };
    }
    constructor(config){
        this.config = config;
        this.createNewContentProperty = async (pageId, key, value, pageType)=>{
            const options = {
                pageId: pageId,
                key: key,
                value: value,
                cloudId: this.config.cloudId,
                pageType: pageType
            };
            if ((0, $gtauf.isBlogPageType)(pageType)) {
                const contentProperty = await (0, $80be7cdfacfd55be$export$548a7902545a91c0)(options);
                if (contentProperty.data.confluence.createBlogPostProperty.blogPostProperty?.key === key) return key;
                else return Promise.reject('Failed to create blog post content property');
            } else {
                const contentProperty = await (0, $80be7cdfacfd55be$export$548a7902545a91c0)(options);
                if (contentProperty.data.confluence.createPageProperty.pageProperty?.key === key) return key;
                else return Promise.reject('Failed to create page content property');
            }
        };
    }
}
/**
 * Factory function to create both providers with shared configuration
 */ const $3f24c0cbcf37c5cb$var$createContentAPIProviders = (config)=>{
    const fetchProvider = new $3f24c0cbcf37c5cb$var$ConfluenceADFFetchProvider(config);
    const writeProvider = new $3f24c0cbcf37c5cb$var$ConfluenceADFWriteProvider(config);
    return {
        fetchProvider: fetchProvider,
        writeProvider: writeProvider
    };
};
const $3f24c0cbcf37c5cb$export$dbf07970755dc340 = (cloudId)=>{
    return $3f24c0cbcf37c5cb$var$createContentAPIProviders({
        cloudId: cloudId,
        contentPropertyKey: 'editor-synced-block'
    });
};
const $3f24c0cbcf37c5cb$export$6b1685237f43a197 = (cloudId)=>{
    return (0, $42omo.useMemo)(()=>{
        return $3f24c0cbcf37c5cb$export$dbf07970755dc340(cloudId);
    }, [
        cloudId
    ]);
};
module.exports["useMemoizedContentAPIProviders"] = $3f24c0cbcf37c5cb$export$6b1685237f43a197;

});

parcelRegister("1RH0O", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $awHlv = parcelRequire("awHlv");


var $i0VEL = parcelRequire("i0VEL");

class $fc26c56016d8bd54$export$dd1cc50ea374801e extends (0, $i0VEL.NodeDataProvider) {
}



var $fm19L = parcelRequire("fm19L");

/* eslint-disable require-unicode-regexp  */ 



var $gtauf = parcelRequire("gtauf");

const $67be479766fa17a3$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $67be479766fa17a3$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $67be479766fa17a3$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $67be479766fa17a3$var$GET_SOURCE_INFO_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_SOURCE_INFO';
/**
 * Query to get the page subtype by id (i.e. live or classic)
 * @param documentARI
 * @returns subType live if livePage, subType null if classic page
 */ const $67be479766fa17a3$var$GET_SOURCE_INFO_QUERY = `query ${$67be479766fa17a3$var$GET_SOURCE_INFO_OPERATION_NAME} ($id: ID!) {
	content (id: $id) {
		nodes {
			id
			links {
				base
			}
			space {
				key
			}
			subType
			title
		}
	}
}`;
const $67be479766fa17a3$var$getSourceInfo = async (ari)=>{
    const bodyData = {
        query: $67be479766fa17a3$var$GET_SOURCE_INFO_QUERY,
        operationName: $67be479766fa17a3$var$GET_SOURCE_INFO_OPERATION_NAME,
        variables: {
            id: ari
        }
    };
    const response = await fetch($67be479766fa17a3$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$67be479766fa17a3$var$COMMON_HEADERS,
            ...$67be479766fa17a3$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get url: ${response.statusText}`);
    return await response.json();
};
const $67be479766fa17a3$export$6232151727613c8d = async (ari, localId)=>{
    try {
        const { type: pageType } = (0, $fm19L.getPageIdAndTypeFromAri)(ari);
        const response = await $67be479766fa17a3$var$getSourceInfo(ari);
        const contentData = response.data?.content?.nodes?.[0];
        if (!contentData) throw new Error(`Failed to get content data`);
        const title = contentData.title;
        let url;
        const { base: base } = contentData.links || {};
        if (base && contentData.space?.key && contentData.id) {
            if ((0, $gtauf.isBlogPageType)(pageType)) url = `${base}/spaces/${contentData.space.key}/blog/edit-v2/${contentData.id}`;
            else if (contentData.subType === 'live') url = `${base}/spaces/${contentData.space.key}/pages/${contentData.id}`;
            else url = `${base}/spaces/${contentData.space.key}/pages/edit-v2/${contentData.id}`;
        }
        url = url && localId ? `${url}#block-${localId}` : url;
        return Promise.resolve({
            title: title,
            url: url
        });
    } catch (error) {
        // TODO: EDITOR-1921 - add error analytics
        return Promise.resolve(undefined);
    }
};


class $082ae0f64f625fc6$export$86215bf52ddaa76d extends (0, $fc26c56016d8bd54$export$dd1cc50ea374801e) {
    isNodeSupported(node) {
        return node.type === 'syncBlock';
    }
    nodeDataKey(node) {
        return node.attrs.localId;
    }
    fetchNodesData(nodes) {
        const resourceIdSet = new Set(nodes.map((node)=>node.attrs.resourceId));
        const resourceIds = [
            ...resourceIdSet
        ];
        return Promise.allSettled(resourceIds.map((resourceId)=>{
            return this.fetchProvider.fetchData(resourceId).then((data)=>{
                return data;
            }, ()=>{
                return {
                    status: (0, $awHlv.SyncBlockError).Errored,
                    resourceId: resourceId
                };
            });
        })).then((results)=>{
            return results.filter((result)=>{
                return result.status === 'fulfilled';
            }).map((result)=>result.value);
        });
    }
    /**
   *
   * @param nodes
   * @param data
   *
   * @returns Array of {resourceId?: string, error?: string}.
   * resourceId: resource id of the node if write successfully , error: reason for when write failed
   */ async writeNodesData(nodes, data) {
        const results = await Promise.allSettled(nodes.map((_node, index)=>{
            if (!data[index].content) return Promise.reject('No Synced Block content to write');
            return this.writeProvider.writeData(data[index]);
        }));
        return results.map((result)=>{
            if (result.status === 'fulfilled') return result.value;
            else return {
                error: result.reason
            };
        });
    }
    async deleteNodesData(resourceIds) {
        const results = await Promise.allSettled(resourceIds.map((resourceId)=>this.writeProvider.deleteData(resourceId)));
        return results.map((result, index)=>{
            if (result.status === 'fulfilled') return result.value;
            else return {
                resourceId: resourceIds[index],
                success: false,
                error: result.reason
            };
        });
    }
    getSourceId() {
        return this.sourceId;
    }
    retrieveSyncBlockSourceInfo(node) {
        const { resourceId: resourceId } = node.attrs;
        let pageARI;
        let sourceLocalId;
        if (resourceId && typeof resourceId === 'string') {
            try {
                pageARI = (0, $fm19L.getPageARIFromResourceId)(resourceId);
            } catch (error) {
                return Promise.reject(error);
            }
            try {
                sourceLocalId = (0, $fm19L.getLocalIdFromAri)(resourceId);
            } catch (error) {
            // EDITOR-1921: log analytic here, safe to continue
            }
        }
        return pageARI ? (0, $67be479766fa17a3$export$6232151727613c8d)(pageARI, sourceLocalId) : Promise.resolve(undefined);
    }
    constructor(fetchProvider, writeProvider, sourceId){
        super();
        this.name = 'syncBlockProvider';
        this.fetchProvider = void 0;
        this.writeProvider = void 0;
        this.sourceId = void 0;
        this.fetchProvider = fetchProvider;
        this.writeProvider = writeProvider;
        this.sourceId = sourceId;
    }
}
const $082ae0f64f625fc6$export$ae97d432056ca005 = (fetchProvider, writeProvider, sourceId)=>{
    return (0, $42omo.useMemo)(()=>{
        return new $082ae0f64f625fc6$export$86215bf52ddaa76d(fetchProvider, writeProvider, sourceId);
    }, [
        fetchProvider,
        writeProvider,
        sourceId
    ]);
};
module.exports["useMemoizedSyncedBlockProvider"] = $082ae0f64f625fc6$export$ae97d432056ca005;

});

parcelRegister("kLzei", function(module, exports) {
/* getSmartCardRenderers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $lzcvT = parcelRequire("lzcvT");


var $i5WUp = parcelRequire("i5WUp");


var $di8q4 = parcelRequire("di8q4");


var $9wGTI = parcelRequire("9wGTI");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $84PmI = parcelRequire("84PmI");

const $1431e51c33a3f61c$var$emojiWrapperStyles = null;
const $1431e51c33a3f61c$var$SmartCardEmojiWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_11c81o8v _1reo15vq _18m915vq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1o8l _1bah1h6o _1ul97vkz"
        ])
    }, children); // Custom render wrapper for AISnippet providing session data
const $1431e51c33a3f61c$var$AISnippetRenderer = (props)=>{
    const { displayName: displayName, userId: userId, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isEligible = (0, $84PmI.useIsEligibleRovoAwareness)();
    const shouldDisplayAwareness = isEligible && (0, $6mKj3.expValEquals)('rovo_awareness_experiment', 'cohort', 'test');
    if (!isAdminHubAIEnabled || (0, $lzcvT.isFedRamp)() || !(0, $6mKj3.expVal)('confluence-ai-linking-ai-snippets', 'should_render_ai_snippet', false)) return props.fallbackComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i5WUp.AISnippetWithRelayEnvironment), {
        ...props,
        showAwareness: shouldDisplayAwareness,
        userId: userId ?? undefined,
        displayName: displayName ?? undefined
    });
};
const $1431e51c33a3f61c$export$61bc672a900b57f = (0, $2XqLN.default)(()=>({
        renderers: {
            emoji: (emojiId, _parentComponent = 'SmartCard', contentType = 'page')=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ge2sX.SessionData), null, (sessionData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                        value: sessionData
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                        emoji: emojiId,
                        height: 16,
                        context: "smartCard",
                        wrapper: $1431e51c33a3f61c$var$SmartCardEmojiWrapper,
                        contentType: contentType
                    }))),
            snippet: (0, $9wGTI.fg)('cc-ai-snippet-renderer-gate') ? $1431e51c33a3f61c$var$AISnippetRenderer : undefined
        }
    }));
module.exports["getSmartCardRenderers"] = $1431e51c33a3f61c$export$61bc672a900b57f;

});

parcelRegister("2SowE", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ function $3c96f0e6009ebcf8$export$dc64ca688fb64c26(payload, newAttributes) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            ...newAttributes
        }
    };
}
const $3c96f0e6009ebcf8$export$a9a68a8b41555f13 = (startTime, duration)=>{
    return Number.isFinite(startTime) && Number.isFinite(duration) ? Math.round(startTime + duration) : undefined;
};
const $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6 = (context)=>{
    return context.filter((obj)=>obj.attributes && typeof obj.attributes === 'object' && !Array.isArray(obj.attributes)).reduce((acc, obj)=>({
            ...acc,
            ...obj.attributes
        }), {});
};
module.exports["extendPayloadAttributes"] = $3c96f0e6009ebcf8$export$dc64ca688fb64c26;
module.exports["getProseMirrorFMPTimestamp"] = $3c96f0e6009ebcf8$export$a9a68a8b41555f13;
module.exports["extractAttributesFromContext"] = $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6;

});

parcelRegister("hEeUR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");


var $jxpvN = parcelRequire("jxpvN");


var $1a6Dn = parcelRequire("1a6Dn");


var $hrAmX = parcelRequire("hrAmX");


var $8WfxO = parcelRequire("8WfxO");





var $3jwuS = parcelRequire("3jwuS");


var $6mKj3 = parcelRequire("6mKj3");

const $134d01bd64a6ba9b$export$e43ca933d3c87145 = ()=>{
    const [forgeAppsHeight, setForgeAppsHeight] = (0, $42omo.useState)($134d01bd64a6ba9b$var$getForgeAppsHeight());
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isForgePageBannerFixed = !isLivePage;
    (0, $42omo.useEffect)(()=>{
        const listener = (e)=>{
            if ((0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false)) setForgeAppsHeight(e?.detail?.height ?? 0);
            else setForgeAppsHeight($134d01bd64a6ba9b$var$getForgeAppsHeight());
        };
        if (isForgePageBannerFixed) document.addEventListener('forgePageBannerHeightUpdated', listener);
        return ()=>{
            if (isForgePageBannerFixed) document.removeEventListener('forgePageBannerHeightUpdated', listener);
        };
    }, [
        isForgePageBannerFixed
    ]);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        forgePageBannerHeight: forgeAppsHeight
    };
};
const $134d01bd64a6ba9b$var$getForgeAppsHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--forge-page-banner-height')) || 0;
};



var $gz8ZY = parcelRequire("gz8ZY");


var $fyKZ5 = parcelRequire("fyKZ5");

const $2a9f51add9ac11ab$export$7cfa481653c48265 = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { includeTopNav: includeTopNav } = (0, $42omo.useContext)((0, $jxpvN.BannerContext));
    const { atlGeneralWebPanelHeight: atlGeneralWebPanelHeight } = (0, $8WfxO.useATLGeneralWebPanelListener)();
    const { forgePageBannerHeight: forgePageBannerHeight } = (0, $134d01bd64a6ba9b$export$e43ca933d3c87145)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer),
            (0, $hrAmX.BannerStateContainer),
            (0, $1a6Dn.FloatingBannerStateContainer)
        ]
    }, (flags, bannerState, floatingBanners)=>{
        const topNavAndBannerHeight = bannerState.getTotalHeight(includeTopNav);
        // if page header is fixed at the top, it adds extra 55px offset
        // However, when there is a theme applied to a space, page headers are not fixed at the top and will not require additional offset.
        const forgePageBannerHeightFeatureFlagged = forgePageBannerHeight;
        const pageHeaderAndBannerHeight = floatingBanners.getFloatingHeight() + (props.isContentHeaderFixedAtTop ? 55 + atlGeneralWebPanelHeight + forgePageBannerHeightFeatureFlagged : 0);
        const stickyTableHeaderOffsetTopForNav3 = topNavAndBannerHeight + pageHeaderAndBannerHeight;
        // topNavAndBannerHeight is outside the scroll root in Nav4
        const stickyTableHeaderOffsetTopForNav4 = pageHeaderAndBannerHeight;
        let stickyTableHeaderConfig = {
            offsetTop: stickyTableHeaderOffsetTopForNav3
        };
        if (isNav4Enabled) stickyTableHeaderConfig = {
            offsetTop: stickyTableHeaderOffsetTopForNav4,
            defaultScrollRootId_DO_NOT_USE: 'AkMainContent',
            shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: true
        };
        // WARNING: PERFORMANCE: <ADFRendererComponent> has been split out from <ADFRenderer>
        // because the child function of <Subscribe> component is called 4-5 times per every
        // transition or initial load. This caused AkRenderer component to be re-rendered the
        // same amount of times, which is quite bad for performance. Split allows to memoize
        // the <ADFRendererComponent> and render it only once.
        //
        // The fact that <ADFRenderer> is used for comments as well makes it even more
        // important to *not* re-render AkRenderer more than once for a page or comment.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fyKZ5.ADFRendererComponent), {
            flags: flags,
            ...stickyTableHeaderConfig,
            ...props
        });
    });
});
$2a9f51add9ac11ab$export$7cfa481653c48265.displayName = 'ADFRenderer';
module.exports["ADFRenderer"] = $2a9f51add9ac11ab$export$7cfa481653c48265;

});

parcelRegister("jxpvN", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $205998aae8e9bd72$export$60bd66ed7962b851 = /*#__PURE__*/ (0, $42omo.createContext)({
    includeTopNav: true
});
$205998aae8e9bd72$export$60bd66ed7962b851.displayName = 'BannerContext';
module.exports["BannerContext"] = $205998aae8e9bd72$export$60bd66ed7962b851;

});

parcelRegister("fyKZ5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $477dG = parcelRequire("477dG");


var $4FxUL = parcelRequire("4FxUL");


var $ibzAc = parcelRequire("ibzAc");


var $67O0h = parcelRequire("67O0h");


var $dh538 = parcelRequire("dh538");


var $fm19L = parcelRequire("fm19L");

var $drwOC = parcelRequire("drwOC");

var $1RH0O = parcelRequire("1RH0O");


var $gtauf = parcelRequire("gtauf");

var $lEQpi = parcelRequire("lEQpi");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $awHlv = parcelRequire("awHlv");

var $a7tZV = parcelRequire("a7tZV");


var $keGcB = parcelRequire("keGcB");


var $bEEXh = parcelRequire("bEEXh");


var $1Wy2j = parcelRequire("1Wy2j");

const $97d9ff76fb12c778$export$da661eaac6059c75 = ({ nodeProps: nodeProps, syncBlockStoreManager: syncBlockStoreManager, rendererOptions: rendererOptions })=>{
    const { resourceId: resourceId, localId: localId, providers: providers } = nodeProps;
    const { syncBlockInstance: syncBlockInstance, isLoading: isLoading } = (0, $a7tZV.useFetchSyncBlockData)(syncBlockStoreManager, resourceId, localId);
    if (isLoading && !syncBlockInstance) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1Wy2j.SyncedBlockLoadingState), {});
    if (syncBlockInstance?.error || !syncBlockInstance?.data) return /*#__PURE__*/ (0, $l998X.jsx)((0, $bEEXh.SyncedBlockErrorComponent), {
        error: syncBlockInstance?.error ?? (0, $awHlv.SyncBlockError).Errored,
        resourceId: resourceId
    });
    const syncBlockDoc = {
        content: syncBlockInstance.data.content,
        version: 1,
        type: 'doc'
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keGcB.AKRendererWrapper), {
        doc: syncBlockDoc,
        dataProviders: providers,
        options: rendererOptions
    });
};


const $5a4beeb4e2a205a9$var$getSyncBlockNodesFromContent = (content)=>{
    return content.map((node)=>(0, $gtauf.convertSyncBlockJSONNodeToSyncBlockNode)(node)).filter((node)=>node !== undefined);
};
const $5a4beeb4e2a205a9$export$3881291633d14c28 = ({ doc: doc, syncBlockProvider: syncBlockProvider, syncBlockRendererOptions: syncBlockRendererOptions })=>{
    const { content: content } = doc;
    const isEmpty = !content || !Array.isArray(content) || content.length === 0;
    const syncBlockNodes = isEmpty ? [] : $5a4beeb4e2a205a9$var$getSyncBlockNodesFromContent(content);
    const syncBlockStoreManager = new (0, $lEQpi.SyncBlockStoreManager)(syncBlockProvider);
    // Pre-fetch sync block data
    syncBlockStoreManager.getReferenceSyncBlockStoreManager().fetchSyncBlocksData(syncBlockNodes);
    return (props)=>(0, $97d9ff76fb12c778$export$da661eaac6059c75)({
            nodeProps: props,
            syncBlockStoreManager: syncBlockStoreManager,
            rendererOptions: syncBlockRendererOptions
        });
};



var $1iSzD = parcelRequire("1iSzD");


var $lJlG6 = parcelRequire("lJlG6");


var $7VJPz = parcelRequire("7VJPz");


var $8cjD5 = parcelRequire("8cjD5");


var $fgQGl = parcelRequire("fgQGl");


var $lhTEt = parcelRequire("lhTEt");


var $i6Ps3 = parcelRequire("i6Ps3");


var $hSHWm = parcelRequire("hSHWm");





var $4cOi8 = parcelRequire("4cOi8");

var $cNwLI = parcelRequire("cNwLI");


var $kcoxM = parcelRequire("kcoxM");


var $lf1vG = parcelRequire("lf1vG");


var $cVaAA = parcelRequire("cVaAA");


var $5Ac5G = parcelRequire("5Ac5G");


var $jmjWc = parcelRequire("jmjWc");


var $bl1ay = parcelRequire("bl1ay");


var $cbvYp = parcelRequire("cbvYp");


const $044598a12ce14eec$export$b55cedbe49066c7 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lL-x8",
    name: "CardsExtensionLoader",
    loader: async ()=>(await (parcelRequire("hFplL"))).CardsExtension
});

const $044598a12ce14eec$var$PlatformSpotlightExtensionLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "d8j05",
    name: "PlatformSpotlightExtensionLoader",
    loader: async ()=>(await (parcelRequire("crH3b"))).SpotlightExtension
});

const $044598a12ce14eec$var$PlatformSearchExtensionLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "24LHW",
    name: "PlatformSearchExtensionLoader",
    loader: async ()=>(await (parcelRequire("5N99w"))).CustomSearchExtension
});

const $044598a12ce14eec$var$LinksMenuLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "khj-w",
    name: "LinksMenuLoader",
    loader: async ()=>(await (parcelRequire("9eTXW"))).LinksMenu
});

const $044598a12ce14eec$var$CarouselLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "iP7CN",
    name: "CarouselLoader",
    loader: async ()=>(await (parcelRequire("1Bhe3"))).Carousel
});
const $044598a12ce14eec$export$2a3fa2b29e6e4046 = ({ contentId: contentId })=>{
    const extensionHandlers = {
        [(0, $kcoxM.CARDS_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        [(0, $5Ac5G.carouselExtensionType)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        [(0, $cVaAA.LINKS_MENU_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        [(0, $bl1ay.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        [(0, $cNwLI.SPOTLIGHT_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        [(0, $lf1vG.SEARCH_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null)
    };
    if (contentId) {
        extensionHandlers[0, $kcoxM.CARDS_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($044598a12ce14eec$export$b55cedbe49066c7, {
                extensionNode: extension,
                contentId: contentId,
                mode: (0, $4cOi8.ExtensionMode).RENDERER,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $5Ac5G.carouselExtensionType] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($044598a12ce14eec$var$CarouselLoader, {
                extensionNode: extension,
                contentId: contentId,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $cVaAA.LINKS_MENU_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($044598a12ce14eec$var$LinksMenuLoader, {
                mode: (0, $4cOi8.ExtensionMode).RENDERER,
                extensionNode: extension,
                contentId: contentId,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $cNwLI.SPOTLIGHT_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($044598a12ce14eec$var$PlatformSpotlightExtensionLoader, {
                contentId: contentId,
                extensionNode: extension,
                mode: (0, $4cOi8.ExtensionMode).RENDERER,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $bl1ay.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE] = ()=>null;
        extensionHandlers[0, $lf1vG.SEARCH_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($044598a12ce14eec$var$PlatformSearchExtensionLoader, {
                mode: (0, $4cOi8.ExtensionMode).RENDERER,
                contentId: contentId,
                extensionNode: extension,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
    }
    return extensionHandlers;
};



var $j5Mgj = parcelRequire("j5Mgj");


var $brsfB = parcelRequire("brsfB");



var $gXrHX = parcelRequire("gXrHX");


var $1SPMi = parcelRequire("1SPMi");


var $yuV6Z = parcelRequire("yuV6Z");


var $kLzei = parcelRequire("kLzei");


var $iP9x4 = parcelRequire("iP9x4");


var $3WO8q = parcelRequire("3WO8q");

var $gxhb8 = parcelRequire("gxhb8");


var $dtVue = parcelRequire("dtVue");


var $4IoVL = parcelRequire("4IoVL");


var $32x2E = parcelRequire("32x2E");


var $jyPfN = parcelRequire("jyPfN");


var $7W8i8 = parcelRequire("7W8i8");



var $ep3mz = parcelRequire("ep3mz");


var $gj42z = parcelRequire("gj42z");


var $4GlQ9 = parcelRequire("4GlQ9");


var $dPJCf = parcelRequire("dPJCf");


var $4o1RV = parcelRequire("4o1RV");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $e4o8D = parcelRequire("e4o8D");


var $6M71K = parcelRequire("6M71K");


var $1h4jS = parcelRequire("1h4jS");


var $ky6OW = parcelRequire("ky6OW");

/* VirtualizedTableComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $jPsgE = parcelRequire("jPsgE");


var $inPa6 = parcelRequire("inPa6");


var $hlcQd = parcelRequire("hlcQd");




const $f534ffd9aa9b82a2$export$bc867bcc0e6599cb = ({ scrollContainerId: scrollContainerId = 'AkMainContent', tableContainerTestId: tableContainerTestId = 'table-container', tableElement: tableElement } = {})=>{
    const parentRef = (0, $42omo.useRef)(null);
    const tableRef = (0, $42omo.useRef)(null);
    const resizeObserverRef = (0, $42omo.useRef)();
    const [scrollMargin, setScrollMargin] = (0, $42omo.useState)(0);
    const getScrollElement = (0, $42omo.useCallback)(()=>{
        const element = document.getElementById(scrollContainerId);
        parentRef.current = element;
        return element;
    }, [
        scrollContainerId
    ]);
    const updateScrollMargin = (0, $42omo.useCallback)(()=>{
        if (!parentRef.current || !tableRef.current) return;
        const parentRect = parentRef.current.getBoundingClientRect();
        const tableRect = tableRef.current.getBoundingClientRect();
        const calculatedScrollMargin = tableRect.top - parentRect.top;
        setScrollMargin(Math.max(0, calculatedScrollMargin));
    }, []);
    // Table ref callback for direct element reference
    const tableRefCallback = (0, $42omo.useCallback)((element)=>{
        tableRef.current = element;
        updateScrollMargin(); // Update when table ref changes
    }, [
        updateScrollMargin
    ]);
    // Set table ref on mount (fallback to querySelector if no direct element provided)
    (0, $42omo.useEffect)(()=>{
        if (tableElement) tableRef.current = tableElement;
        else {
            //TODO: Change the approach to work for multiple tables on one page
            const foundElement = document.querySelector(`[data-testid="${tableContainerTestId}"]`);
            if (foundElement && foundElement instanceof HTMLElement) tableRef.current = foundElement;
            else tableRef.current = null;
        }
    }, [
        tableContainerTestId,
        tableElement
    ]);
    // Set up ResizeObserver and initial scroll margin calculation
    (0, $42omo.useEffect)(()=>{
        // Initialize parent ref
        getScrollElement();
        const observer = new ResizeObserver(()=>{
            updateScrollMargin();
        });
        resizeObserverRef.current = observer;
        // Observe both parent and table elements
        if (parentRef.current) observer.observe(parentRef.current);
        if (tableRef.current) observer.observe(tableRef.current);
        // Initial update
        updateScrollMargin();
        return ()=>{
            observer.disconnect();
        };
    }, [
        updateScrollMargin,
        getScrollElement
    ]);
    return {
        scrollMargin: scrollMargin,
        updateScrollMargin: updateScrollMargin,
        tableRef: tableRefCallback
    };
};






var $dWvqY = parcelRequire("dWvqY");

const $ed8edb7d474ec91b$export$8153cc1d3e4d73ca = [
    'codeBlock',
    'embedCard',
    'expand',
    'nestedExpand',
    'heading',
    'extension',
    'extensionFrame',
    'bodiedExtension',
    'multiBodiedExtension',
    'inlineExtension'
];
const $ed8edb7d474ec91b$var$alwaysRangeExtractor = (childInfo)=>{
    return (childInfo?.childrenNodeTypeCounts || []).reduce((acc, childNodeTypeCounts, index)=>{
        // Add row 0 to always include the header row. This is important because, at the time of writing,
        // adding and removing it from the DOM results in the unstable keys for the tables rows.
        // Technically, it may not be a header row. However, it is just 1 row and it is simpler to just always include it.
        const isHeaderRow = index === 0;
        // Virtualization is disabled if any unsupported child node types are present.
        const isUnsupportedRow = $ed8edb7d474ec91b$export$8153cc1d3e4d73ca.some((nodeType)=>childNodeTypeCounts[nodeType]);
        // Virtualization is disabled if any annotations, such as inline comments, are present.
        const isAnnotationRow = childInfo?.childrenHasAnnotations[index];
        if (isHeaderRow || isUnsupportedRow || isAnnotationRow) acc.push(index);
        return acc;
    }, []);
};
const $ed8edb7d474ec91b$var$combineRanges = (rangeA, rangeB)=>{
    const combinedRange = [];
    let rangeAIndex = 0;
    let rangeBIndex = 0;
    while(rangeAIndex < rangeA.length || rangeBIndex < rangeB.length){
        const rangeAValue = rangeA[rangeAIndex];
        const rangeBValue = rangeB[rangeBIndex];
        if (!Number.isInteger(rangeBValue) || rangeBValue > rangeAValue) {
            // Add element because it's in range A.
            combinedRange.push(rangeAValue);
            rangeAIndex++;
        } else if (!Number.isInteger(rangeAValue) || rangeAValue > rangeBValue) {
            // Add element because it's in range B.
            combinedRange.push(rangeBValue);
            rangeBIndex++;
        } else {
            // Add element because it's in both ranges.
            combinedRange.push(rangeAValue);
            rangeAIndex++;
            rangeBIndex++;
        }
    }
    return combinedRange;
};
const $ed8edb7d474ec91b$export$42370a11bc89a2aa = (childInfo)=>{
    const alwaysRange = (0, $42omo.useMemo)(()=>$ed8edb7d474ec91b$var$alwaysRangeExtractor(childInfo), [
        childInfo
    ]);
    return (0, $42omo.useCallback)((range)=>{
        const defaultRange = (0, $dWvqY.defaultRangeExtractor)(range);
        const combinedRange = $ed8edb7d474ec91b$var$combineRanges(defaultRange, alwaysRange);
        return combinedRange;
    }, [
        alwaysRange
    ]);
};


const $2aa6fc54947bb004$export$c576b800ffd77e43 = ({ children: children, parentInfo: parentInfo, childInfo: childInfo, ...otherTableProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const childrenArray = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children), [
        children
    ]); // Returns the main content container which serves as the scroll container
    const getScrollElement = (0, $42omo.useCallback)(()=>{
        return document.getElementById('AkMainContent');
    }, []); // scrollMargin is used to specify where the scroll offset should originate.
    // This value is the space between the beginning of the scrolling element
    // i.e. the top of AkMainContent and till the start of the table.
    const { scrollMargin: scrollMargin } = (0, $f534ffd9aa9b82a2$export$bc867bcc0e6599cb)(); // Tracks the Y-coordinate difference between the main content and table
    // Used for accurate remaining height calculations in virtual scrolling
    const [yCoordinateDifference, setYCoordinateDifference] = (0, $42omo.useState)(0);
    (0, $42omo.useEffect)(()=>{
        const mainContent = document.getElementById('AkMainContent');
        const table = document.querySelector('[data-testid="renderer-table"]');
        if (!mainContent || !table) return;
        const mainContentRect = mainContent.getBoundingClientRect();
        const tableRect = table.getBoundingClientRect();
        const finalDifference = tableRect.top - mainContentRect.top;
        setYCoordinateDifference(finalDifference);
    }, []);
    const customRangeExtractor = (0, $ed8edb7d474ec91b$export$42370a11bc89a2aa)(childInfo); /**
                                                                    * Core virtualizer configuration:
                                                                    * - enabled: Always true for this component
                                                                    * - count: Total number of table rows
                                                                    * - estimateSize: Estimated height per row - used for initial calculations
                                                                    * - overscan: Number of items to render outside viewport for smooth scrolling
                                                                    * - scrollMargin: Offset for scroll positioning
                                                                    * - rangeExtractor: Custom logic for determining which items to render
                                                                    */ 
    const virtualizer = (0, $jPsgE.useVirtualizer)({
        enabled: true,
        count: childrenArray.length,
        getScrollElement: getScrollElement,
        estimateSize: ()=>44,
        // Standard table row height in Confluence
        overscan: 5,
        scrollMargin: scrollMargin,
        rangeExtractor: customRangeExtractor
    });
    const virtualItems = virtualizer.getVirtualItems(); //calculate column count from a table row element
    const calculateColumnCount = (0, $42omo.useCallback)((rowElement)=>{
        let totalColumns = 0;
        const traverseElement = (element)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(element)) return;
            const props = element.props;
            if (props.children && Array.isArray(props.children)) props.children.forEach((cell)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(cell)) {
                    const cellProps = cell.props;
                    totalColumns += cellProps?.colspan ?? 1;
                }
            });
        };
        traverseElement(rowElement);
        return totalColumns;
    }, []);
    // column count calculation based on first row
    const columnCount = (0, $42omo.useMemo)(()=>{
        if (childrenArray.length > 0) {
            const rowElement = childrenArray[0];
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(rowElement)) return calculateColumnCount(rowElement);
        }
        return 0;
    }, [
        childrenArray,
        calculateColumnCount
    ]);
    // Renders only the visible table rows plus a spacer row to maintain total height
    const renderVirtualRows = (0, $42omo.useCallback)(()=>{
        const virtualRowsToRender = virtualItems.map((virtualRow)=>childrenArray[virtualRow.index]); // Calculate remaining height below the last visible row
        // This spacer maintains the illusion of a full-height table
        const lastVirtualItem = virtualItems[virtualItems.length - 1];
        const remainingHeight = lastVirtualItem ? virtualizer.getTotalSize() - (lastVirtualItem.start + lastVirtualItem.size) + yCoordinateDifference : 0; // Add spacer row to fill remaining height and maintain scroll behavior
        if (remainingHeight > 0 && columnCount > 0) virtualRowsToRender.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("tr", {
            key: "spacer-row",
            style: {
                height: `${remainingHeight}px`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("td", {
            key: `spacer-cell`,
            colSpan: columnCount,
            className: (0, $gMc0m.default)([
                "_4t3i1osq"
            ])
        })));
        return virtualRowsToRender;
    }, [
        virtualItems,
        childrenArray,
        virtualizer,
        yCoordinateDifference,
        columnCount
    ]);
    const TableComponent = (0, $hlcQd.nodeToReact).table;
    const tableWrapperRef = (0, $42omo.useRef)(null); // Only enable virtualization for top-level tables
    const isVirtualizationEnabled = (parentInfo?.path?.length || 0) < 2;
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'render',
                actionSubject: 'virtualizedTable',
                attributes: {
                    isVirtualizationEnabled: isVirtualizationEnabled,
                    parentPathLength: parentInfo?.path?.length || 0,
                    unsupportedChildNodeTypeCounts: (0, $ed8edb7d474ec91b$export$8153cc1d3e4d73ca).reduce((acc, nodeType)=>({
                            ...acc,
                            [nodeType]: childInfo?.selfNodeTypeCounts?.[nodeType] || 0
                        }), {})
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isVirtualizationEnabled,
        parentInfo,
        childInfo
    ]);
    (0, $42omo.useEffect)(()=>{
        const wrapper = document.querySelector('.pm-table-wrapper');
        const table = document.querySelector('[data-testid="renderer-table"]');
        if (wrapper) {
            // Set total height to accommodate all virtual rows
            wrapper.style.height = `${virtualizer.getTotalSize()}px`;
            wrapper.style.width = '100%';
            wrapper.style.position = 'relative';
            wrapper.style.overflow = 'hidden';
            tableWrapperRef.current = wrapper;
        }
        if (table) table.style.height = `100%`;
    }, [
        virtualizer,
        virtualItems
    ]);
    if (!isVirtualizationEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TableComponent, otherTableProps, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(TableComponent, otherTableProps, renderVirtualRows());
};



var $edEsl = parcelRequire("edEsl");


var $04e9M = parcelRequire("04e9M");


var $hp2SH = parcelRequire("hp2SH");


var $eXfot = parcelRequire("eXfot");

async function $ad68e9e7df73622d$export$ee66267d3930a21(contentId, batch) {
    const updateBatch = batch.map((update)=>{
        const { objectKey: objectKey, state: state } = update;
        const status = state === 'DONE' ? 'CHECKED' : 'UNCHECKED';
        return {
            taskId: objectKey.localId,
            status: status
        };
    });
    const taskBatch = {
        contentId: contentId,
        tasks: updateBatch,
        trigger: 'VIEW_PAGE'
    };
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        return await (0, $hp2SH.getApolloClient)().mutate({
            mutation: (0, $eXfot.SetBatchedTaskStatusMutation),
            variables: taskBatch
        });
    } catch (error) {
        const client = await (0, $04e9M.getAnalyticsWebClient)();
        client.sendOperationalEvent({
            source: 'page',
            action: 'batchTaskUpdate',
            actionSubject: 'checkbox',
            attributes: {
                error: error.message || String(error),
                stack: error.stack
            }
        });
    }
}



var $kyRHQ = parcelRequire("kyRHQ");

const $1af8a83cb114ff50$export$3422b9c70e187e34 = {
    enabled: true,
    severityDegradedThreshold: 4747,
    severityNormalThreshold: 3775
};
const $1af8a83cb114ff50$var$logger = (0, $7W8i8.getLogger)('ADFRenderer');
const $1af8a83cb114ff50$export$c02e908ea3c1fe52 = {
    enabled: true,
    thresholds: {
        blocking: 1.5,
        degraded: 1
    }
};
const $1af8a83cb114ff50$var$mergeDataProviders = ({ hasViewUserProfilePermission: hasViewUserProfilePermission, handleActionToggle: handleActionToggle, handleInviteItemClick: handleInviteItemClick, getDataProviders: getDataProviders, providerFactory: providerFactory, isExternalShare: isExternalShare, contentId: contentId, spaceKey: spaceKey, pageContextContentId: pageContextContentId, cloudId: cloudId, userId: userId, userRole: userRole, flags: flags, profilecardProvider: profilecardProvider, intl: intl, mediaToken: mediaToken, emojiResourceParams: emojiResourceParams })=>{
    const providers = {};
    if (getDataProviders) Object.assign(providers, getDataProviders());
    if (contentId || mediaToken) {
        providers.mediaProvider = (0, $4IoVL.createRendererMediaProvider)({
            contentId: contentId,
            spaceKey: spaceKey,
            mediaDspContentId: pageContextContentId,
            isExternalShare: isExternalShare,
            mediaToken: mediaToken
        });
        providers.taskDecisionProvider = Promise.resolve(new (0, $3WO8q.ConfluenceTaskDecisionProvider)(intl, flags, contentId, handleActionToggle));
    }
    if (cloudId && userId) providers.mentionProvider = (0, $dtVue.createMentionsConfig)(cloudId, userId, undefined, undefined, handleInviteItemClick, userRole).then((config)=>config.mentionResource).catch((err)=>{
        if ($kyRHQ.env.NODE_ENV !== 'production') $1af8a83cb114ff50$var$logger.error`Failed to initialise mention resource ${err}`;
        return Promise.reject();
    });
    if (emojiResourceParams && cloudId) providers.emojiProvider = (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        ...emojiResourceParams,
        allowAnonymousAccess: true
    });
    if (cloudId) // If global view user profile is enabled then user can view profile card
    {
        if (hasViewUserProfilePermission) providers.profilecardProvider = profilecardProvider;
    }
    if (contentId && spaceKey) providers.contextIdentifierProvider = Promise.resolve({
        containerId: spaceKey,
        objectId: contentId,
        product: 'confluence'
    });
    providers.cardProvider = Promise.resolve(new (0, $477dG.EditorCardProvider)(undefined, undefined, 'CONFLUENCE'));
    const keys = Object.keys(providers);
    if (keys.length) {
        providerFactory = providerFactory || (0, $4FxUL.default).create({});
        for (const provider of Object.keys(providers))providerFactory.setProvider(provider, providers[provider]);
    }
    return providerFactory;
};
const $1af8a83cb114ff50$var$projectLinkerHandlers = {
    'com.atlassian.confluence.project-linker': ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null)
};
const $1af8a83cb114ff50$export$58eac04eb6213951 = ()=>(0, $dh538.fg)('platform_renderer_unsupported_content_tracking') ? $1af8a83cb114ff50$export$c02e908ea3c1fe52 : undefined;
const $1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS = {};
const $1af8a83cb114ff50$var$DEFAULT_GET_EXTENSION_HANDLERS = ()=>$1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS;
const $1af8a83cb114ff50$var$DEFAULT_EXTENSION_VIEWPORT_SIZES = [];
const $1af8a83cb114ff50$export$cec675c14d32c246 = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { document: document, dataProviders: dataProviders, extensionHandlers: extensionHandlers = $1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS, getExtensionHandlers: getExtensionHandlers = $1af8a83cb114ff50$var$DEFAULT_GET_EXTENSION_HANDLERS, eventHandlers: eventHandlers, appearance: appearance, contentMode: contentMode, adfStage: adfStage = 'stage0', portal: portal, onRendered: onRendered, renderWhenReady: renderWhenReady, allowStickyHeaders: allowStickyHeaders = true, allowPlaceholderText: allowPlaceholderText = false, isTruncatedContent: isTruncatedContent, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, flags: flags, offsetTop: offsetTop, defaultScrollRootId_DO_NOT_USE: defaultScrollRootId_DO_NOT_USE, shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE, mediaToken: mediaToken, onError: onError, UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment = true, UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing = true, UNSTABLE_isPresentational: UNSTABLE_isPresentational = false, extensionViewportSizes: extensionViewportSizes = $1af8a83cb114ff50$var$DEFAULT_EXTENSION_VIEWPORT_SIZES, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail, allowRendererContainerStyles: allowRendererContainerStyles, ...rest } = props;
    const intl = (0, $8C5kA.default)();
    const [isTaskToggled, setIsTaskToggled] = (0, $42omo.useState)(false);
    const initialState = window['__SSR_SMARTLINKS__'];
    const isPageSSR = (0, $i6Ps3.isPageSSRd)();
    const storeOptions = (0, $lhTEt.useStoreOptions)(initialState, isPageSSR);
    // Fix for HOT-99954 - Issue where embedded pages SSR SmartLinks open in same tab
    const shouldSSRsmartLinks = isPageSSR && !(0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() && !(0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const { cloudId: cloudId, userId: userId, featureFlags: featureFlags, isLicensed: isLicensed, isLoggedIn: isLoggedIn, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [pageContextContentId] = (0, $ep3mz.usePageContentId)();
    const [pageContextContentType] = (0, $ep3mz.useContentType)();
    const { openCoreInvites: openCoreInvites, userRole: userRole } = (0, $42omo.useContext)((0, $hSHWm.CoreInvitesContext));
    const [shouldRefetchContent, setShouldRefetchContent] = (0, $42omo.useState)(false);
    const contentId = props.contentId || pageContextContentId;
    const contentType = props.contentType || pageContextContentType;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const taskBatcherRef = (0, $42omo.useRef)(new (0, $gxhb8.TaskBatcher)((0, $6mKj3.expVal)('confluence_frontend_task_batching_interval', 'value', 3000)));
    const feedFollowData = (0, $4GlQ9.useFeedFollow)();
    // Handlers for batched task update
    const handleBatchTaskUpdate = (0, $42omo.useCallback)((batch)=>{
        // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
        (0, $ad68e9e7df73622d$export$ee66267d3930a21)(contentId, batch).then(()=>{
            setIsTaskToggled(false);
            setShouldRefetchContent(true);
        });
    }, [
        contentId,
        setShouldRefetchContent
    ]);
    const handleActionToggle = (0, $42omo.useCallback)((objectKey, state)=>{
        setIsTaskToggled(true);
        taskBatcherRef.current.add({
            objectKey: objectKey,
            state: state
        });
    }, [
        taskBatcherRef
    ]);
    (0, $42omo.useEffect)(()=>{
        // there is a document check - we do not want to call registerGlobalMediaViewedListener
        // with no content
        if (document) (0, $edEsl.registerGlobalMediaViewedListener)();
        onRendered && onRendered();
        taskBatcherRef.current.onFlush(handleBatchTaskUpdate);
        return ()=>{
            if (document) (0, $edEsl.removeGlobalMediaViewedListener)();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        taskBatcherRef,
        handleBatchTaskUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        setShouldRefetchContent(false);
    // WS-4098 - When the contentId changes or when we mount we don't need to refetch
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleBeforeUnload = (event)=>{
            if (isTaskToggled) {
                event.preventDefault();
                event.returnValue = ''; // This triggers the alert in all browsers
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isTaskToggled,
        contentId
    ]);
    // Setting up emoji resources for ssr and data providers
    const emojiResourceParams = (0, $42omo.useMemo)(()=>{
        if (cloudId) return (0, $yuV6Z.createEmojiProviderParameters)({
            cloudId: cloudId,
            userId: userId,
            isLicensed: isLicensed,
            isLoggedIn: isLoggedIn,
            onEmojiLoadSuccess: onEmojiLoadSuccess,
            onEmojiLoadFail: onEmojiLoadFail
        });
    }, [
        cloudId,
        userId,
        isLicensed,
        isLoggedIn,
        onEmojiLoadSuccess,
        onEmojiLoadFail
    ]);
    const emojiResourceConfig = (0, $42omo.useMemo)(()=>{
        if (emojiResourceParams) return (0, $32x2E.getEmojiConfig)(emojiResourceParams.cloudId, emojiResourceParams.userId, emojiResourceParams.disableUpload, emojiResourceParams.emojiSSRConfig, undefined, emojiResourceParams.emojiLoadCallbacks);
    }, [
        emojiResourceParams
    ]);
    const { isExternalShareRequest: isExternalShareRequest } = (0, $42omo.useContext)((0, $gXrHX.ExternalShareContext));
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const mergedExtensionHandlers = (0, $42omo.useMemo)(()=>{
        return {
            ...getExtensionHandlers?.(),
            ...extensionHandlers,
            ...(0, $044598a12ce14eec$export$2a3fa2b29e6e4046)({
                contentId: contentId
            }),
            ...(0, $7VJPz.getRendererSmartButtonExtensionHandlers)({
                contentId: contentId,
                contentType: contentType,
                cloudId: cloudId
            }),
            ...$1af8a83cb114ff50$var$projectLinkerHandlers
        };
    }, [
        extensionHandlers,
        getExtensionHandlers,
        contentId,
        contentType,
        cloudId
    ]);
    const mediaSSR = (0, $iP9x4.useMediaSSRModeAndAuthConfig)({
        contentId: contentId,
        spaceKey: spaceKey,
        isExternalShare: isExternalShareRequest,
        mediaToken: mediaToken
    });
    // -- Matches fabric-feature-flags.ts
    const isStickyHeadersEnabled = allowStickyHeaders;
    const errorHandler = (0, $42omo.useCallback)((error)=>{
        onError?.(error);
    }, [
        onError
    ]);
    const { shimAdfUrls: shimAdfUrls } = (0, $4o1RV.useNavigationPolicy)();
    const editorFeatureFlags = (0, $j5Mgj.useEditorFeatureFlags)();
    const profilecardProvider = (0, $brsfB.useProfilecardProvider)({
        push: push,
        userId: userId,
        cloudId: cloudId,
        featureFlags: featureFlags
    });
    const shouldControlDataExport = (0, $4IoVL.controlDataExportOnCertainFeatures)(window.location.pathname);
    // ----------------------------------
    const allowHeadingAnchorLinks = (0, $42omo.useMemo)(()=>({
            allowNestedHeaderLinks: true,
            activeHeadingId: props.queryHash
        }), [
        props.queryHash
    ]);
    const media = (0, $42omo.useMemo)(()=>({
            allowLinking: true,
            allowCaptions: true,
            featureFlags: {
                mediaInline: true
            },
            ssr: mediaSSR
        }), [
        mediaSSR
    ]);
    const { isEligibleCreateNewWhiteboard: isEligibleCreateNewWhiteboard } = (0, $1h4jS.useIsEligibleCreateNewWhiteboard)();
    const { fetchProvider: fetchProvider, writeProvider: writeProvider } = (0, $drwOC.useMemoizedContentAPIProviders)(cloudId);
    const syncedBlockProvider = (0, $1RH0O.useMemoizedSyncedBlockProvider)(fetchProvider, writeProvider, // we don't actually use the page ari for renderer reference sync blocks, so it is okay if contentId is undefined
    (0, $fm19L.getConfluencePageAri)(contentId ?? '', cloudId, contentType === 'page' ? 'page' : 'blogpost'));
    const nodeComponents = (0, $42omo.useMemo)(()=>{
        const virtualizedTableComponent = (0, $6mKj3.expVal)('confluence_frontend_virtualized_tables', 'isEnabled', false) ? {
            table: (0, $2aa6fc54947bb004$export$c576b800ffd77e43)
        } : undefined;
        if ((0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) return {
            syncBlock: (0, $5a4beeb4e2a205a9$export$3881291633d14c28)({
                syncBlockProvider: syncedBlockProvider,
                doc: document,
                syncBlockRendererOptions: undefined
            }),
            ...virtualizedTableComponent || {}
        };
        else return virtualizedTableComponent;
    }, [
        syncedBlockProvider,
        document
    ]);
    const smartLinks = (0, $42omo.useMemo)(()=>({
            ssr: shouldSSRsmartLinks,
            hideHoverPreview: false,
            CompetitorPrompt: isEligibleCreateNewWhiteboard ? (0, $ky6OW.PromptPopupContainer) : undefined
        }), [
        shouldSSRsmartLinks,
        isEligibleCreateNewWhiteboard
    ]);
    const stickyHeaders = (0, $42omo.useMemo)(()=>isStickyHeadersEnabled ? {
            offsetTop: offsetTop,
            defaultScrollRootId_DO_NOT_USE: defaultScrollRootId_DO_NOT_USE,
            shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE
        } : undefined, [
        isStickyHeadersEnabled,
        offsetTop,
        defaultScrollRootId_DO_NOT_USE,
        shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE
    ]);
    if (!document) return null;
    const mergedDataProviders = $1af8a83cb114ff50$var$mergeDataProviders({
        contentId: // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
        contentId,
        spaceKey: // @ts-ignore FIXME: `spaceKey` can be `undefined` here, and needs proper handling
        spaceKey,
        pageContextContentId: pageContextContentId,
        cloudId: cloudId,
        userId: userId,
        flags: flags,
        featureFlags: featureFlags,
        push: push,
        intl: intl,
        providerFactory: dataProviders,
        profilecardProvider: profilecardProvider,
        isExternalShare: isExternalShareRequest,
        handleActionToggle: handleActionToggle,
        hasViewUserProfilePermission: hasViewUserProfilePermission,
        handleInviteItemClick: openCoreInvites,
        userRole: userRole,
        mediaToken: mediaToken,
        emojiResourceParams: emojiResourceParams
    });
    const finalDocument = shimAdfUrls(document);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (appearance === 'full-page' || appearance === 'full-width') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8cjD5.PageLoadMark), {
        "data-testid": "pageLoadMarkTestId",
        name: "onBeforeAkRenderer"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1SPMi.RendererAnalyticsListener), {
        // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
        objectId: contentId,
        objectType: contentType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67O0h.RendererWithAnalytics), {
        // This flag is used for fixing table width in SSR mode and for hydration
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        enableSsrInlineScripts: Boolean(undefined),
        // include renderer inline script from above on first render to prevent hydration mismatch
        noOpSSRInlineScript: renderServerPlaceholder,
        adfStage: adfStage,
        document: finalDocument,
        appearance: appearance,
        contentMode: contentMode,
        stickyHeaders: stickyHeaders,
        extensionHandlers: mergedExtensionHandlers,
        eventHandlers: eventHandlers,
        featureFlags: editorFeatureFlags,
        dataProviders: mergedDataProviders,
        portal: portal,
        allowColumnSorting: true,
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        allowAltTextOnImages: true,
        media: media,
        emojiResourceConfig: emojiResourceConfig,
        allowCopyToClipboard: true,
        allowWrapCodeBlock: true,
        ...rest,
        useSpecBasedValidator: true,
        truncated: isTruncatedContent,
        maxHeight: maxHeight,
        fadeOutHeight: fadeOutHeight,
        analyticsEventSeverityTracking: $1af8a83cb114ff50$export$3422b9c70e187e34,
        unsupportedContentLevelsTracking: $1af8a83cb114ff50$export$58eac04eb6213951(),
        allowPlaceholderText: allowPlaceholderText,
        allowCustomPanels: true,
        smartLinks: smartLinks,
        extensionViewportSizes: extensionViewportSizes,
        onError: errorHandler,
        UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment,
        UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing,
        UNSTABLE_isPresentational: UNSTABLE_isPresentational,
        allowRendererContainerStyles: allowRendererContainerStyles,
        ...nodeComponents && {
            nodeComponents: nodeComponents
        }
    }), renderWhenReady && renderWhenReady()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fgQGl.ContentRefetchHandler), {
        contentId: contentId,
        shouldRefetch: shouldRefetchContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedFollowData.feedConfigError,
        mutationError: feedFollowData.mutationError,
        showErrorFlag: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        ...(0, $kLzei.getSmartCardRenderers)(),
        ...storeOptions,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        shouldControlDataExport: shouldControlDataExport,
        product: "CONFLUENCE"
    }, content));
});
module.exports["ANALYTICS_EVENT_SEVERITY_TRACKING"] = $1af8a83cb114ff50$export$3422b9c70e187e34;
module.exports["UNSUPPORTED_CONTENT_THRESHOLDS"] = $1af8a83cb114ff50$export$c02e908ea3c1fe52;
module.exports["ADFRendererComponent"] = $1af8a83cb114ff50$export$cec675c14d32c246;

});

parcelRegister("keGcB", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hlcQd = parcelRequire("hlcQd");

var $67O0h = parcelRequire("67O0h");

var $iZq0X = parcelRequire("iZq0X");


var $lspPP = parcelRequire("lspPP");

const $a04998616bd329fd$var$ValidationContextWrapper = ({ children: children })=>{
    const validationContextValue = (0, $42omo.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iZq0X.ValidationContextProvider), {
        value: validationContextValue,
        children: children
    });
};
const $a04998616bd329fd$var$defaultOptions = {
    allowAltTextOnImages: true,
    allowAnnotations: true,
    allowColumnSorting: true,
    allowCopyToClipboard: true,
    allowCustomPanels: true,
    allowPlaceholderText: true,
    allowRendererContainerStyles: true,
    allowSelectAllTrap: true,
    allowUgcScrubber: true,
    allowWrapCodeBlock: true,
    emojiResourceConfig: undefined,
    media: {
        allowLinking: true,
        allowCaptions: true,
        featureFlags: {
            mediaInline: true
        }
    },
    smartLinks: undefined,
    stickyHeaders: true
};
const $a04998616bd329fd$export$cc2ec5e10e7ca244 = /*#__PURE__*/ (0, $42omo.memo)(({ doc: doc, dataProviders: dataProviders, options: options })=>{
    const mergedOptions = {
        ...$a04998616bd329fd$var$defaultOptions,
        ...options
    };
    const { allowAltTextOnImages: allowAltTextOnImages, allowAnnotations: allowAnnotations, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowCustomPanels: allowCustomPanels, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowRendererContainerStyles: allowRendererContainerStyles, allowSelectAllTrap: allowSelectAllTrap, allowUgcScrubber: allowUgcScrubber, allowWrapCodeBlock: allowWrapCodeBlock, emojiResourceConfig: emojiResourceConfig, media: media, smartLinks: smartLinks, stickyHeaders: stickyHeaders } = mergedOptions ?? {};
    const nodeComponents = (0, $42omo.useMemo)(()=>{
        return {
            taskItem: (props)=>{
                const TaskItem = (0, $hlcQd.nodeToReact)['taskItem'];
                // eslint-disable-next-line react/jsx-props-no-spreading
                return /*#__PURE__*/ (0, $l998X.jsx)(TaskItem, {
                    ...props,
                    disabled: true
                });
            },
            blockTaskItem: (props)=>{
                const BlockTaskItem = (0, $hlcQd.nodeToReact)['blockTaskItem'];
                // eslint-disable-next-line react/jsx-props-no-spreading
                return /*#__PURE__*/ (0, $l998X.jsx)(BlockTaskItem, {
                    ...props,
                    disabled: true
                });
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lspPP.RendererActionsContext), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($a04998616bd329fd$var$ValidationContextWrapper, {
            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                "data-testid": "sync-block-renderer-wrapper",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $67O0h.default), {
                    appearance: "full-width",
                    adfStage: "stage0",
                    document: doc,
                    disableHeadingIDs: true,
                    dataProviders: dataProviders,
                    nodeComponents: nodeComponents,
                    allowAltTextOnImages: allowAltTextOnImages,
                    allowAnnotations: allowAnnotations,
                    allowColumnSorting: allowColumnSorting,
                    allowCopyToClipboard: allowCopyToClipboard,
                    allowCustomPanels: allowCustomPanels,
                    allowHeadingAnchorLinks: allowHeadingAnchorLinks,
                    allowPlaceholderText: allowPlaceholderText,
                    allowRendererContainerStyles: allowRendererContainerStyles,
                    allowSelectAllTrap: allowSelectAllTrap,
                    allowUgcScrubber: allowUgcScrubber,
                    allowWrapCodeBlock: allowWrapCodeBlock,
                    emojiResourceConfig: emojiResourceConfig,
                    media: media,
                    smartLinks: smartLinks,
                    stickyHeaders: stickyHeaders
                })
            })
        })
    });
});
module.exports["AKRendererWrapper"] = $a04998616bd329fd$export$cc2ec5e10e7ca244;

});

parcelRegister("bEEXh", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e6n00 = parcelRequire("e6n00");


var $fm19L = parcelRequire("fm19L");

var $awHlv = parcelRequire("awHlv");




/**
 * @generated SignedSource<<3bfb9487e57255dc0512f225894a058b>>
 * @relayHash 676631e44ffd7d0d16b3a7e96ba02def
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 68a651ca7e5a5c9b5a075954ed948672c451b0f8c255f4edbd3219fe4947484d
const $81e8fecca2e99343$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "requestPageAccessInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "requestPageAccessInput",
                    "variableName": "requestPageAccessInput"
                }
            ],
            "concreteType": "RequestPageAccessPayload",
            "kind": "LinkedField",
            "name": "requestPageAccess",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SyncedBlockPermissionDeniedRequestAccessMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SyncedBlockPermissionDeniedRequestAccessMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "68a651ca7e5a5c9b5a075954ed948672c451b0f8c255f4edbd3219fe4947484d",
            "metadata": {},
            "name": "SyncedBlockPermissionDeniedRequestAccessMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$81e8fecca2e99343$var$node.hash = "d0d4982ad805583380d2436a8e21ee6a";
var $81e8fecca2e99343$export$2e2bcd8739ae039 = $81e8fecca2e99343$var$node;



var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $irOoi = parcelRequire("irOoi");


var $ccHMk = parcelRequire("ccHMk");


var $fzXn1 = parcelRequire("fzXn1");


var $7hXDW = parcelRequire("7hXDW");


var $3sFtD = parcelRequire("3sFtD");


var $gj7hi = parcelRequire("gj7hi");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");

var $682ccca673fecc9d$exports = {};
$682ccca673fecc9d$exports = new URL("PermissionDenied.bfcb6211.svg", import.meta.url).toString();


const $a081b56695b04c74$var$styles = {
    wrapper: "_2rko12b0 _zulpu2gc _ca0qv47k _n3tdv47k _19bvxy5q _u5f3v47k _bfhkby5v _1e0c1txw _1bahv2br _4cvr1h6o",
    textWrapper: "_18u0u2gc"
};
var $a081b56695b04c74$var$RequestAccessState = /*#__PURE__*/ function(RequestAccessState) {
    RequestAccessState["default"] = "default";
    RequestAccessState["errored"] = "errored";
    RequestAccessState["loading"] = "loading";
    RequestAccessState["pending"] = "pending";
    return RequestAccessState;
}($a081b56695b04c74$var$RequestAccessState || {});
const $a081b56695b04c74$export$33325aff698460b9 = ({ contentId: contentId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [requestAccessState, setRequestAccessState] = (0, $42omo.useState)("default");
    const handleRequestComplete = ()=>{
        setRequestAccessState("pending");
    };
    const handleRequestError = (error)=>{
        setRequestAccessState("errored");
    };
    const [commitMutation] = (0, $irOoi.useMutation)((0, $81e8fecca2e99343$export$2e2bcd8739ae039));
    const onClick = ()=>{
        setRequestAccessState("loading");
        commitMutation({
            variables: {
                requestPageAccessInput: {
                    pageId: contentId,
                    accessType: 'VIEW'
                }
            },
            onCompleted: ()=>{
                handleRequestComplete();
            },
            onError: handleRequestError
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $a081b56695b04c74$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($682ccca673fecc9d$exports))),
                alt: formatMessage((0, $fzXn1.syncBlockMessages).permissionDeniedAltText),
                width: "48",
                height: "48"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.100",
                alignInline: "start",
                xcss: $a081b56695b04c74$var$styles.textWrapper,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                        size: "xsmall",
                        children: formatMessage((0, $fzXn1.syncBlockMessages).permissionDeniedHeading)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.subtle",
                        children: formatMessage((0, $fzXn1.syncBlockMessages).permissionDeniedDescription)
                    }),
                    requestAccessState === "pending" ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                        columnGap: "space.050",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                                size: "small",
                                color: "var(--ds-icon-subtle, #505258)",
                                label: ""
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text.subtlest",
                                weight: "bold",
                                testId: "sync-block-access-requested-msg",
                                children: formatMessage((0, $fzXn1.syncBlockMessages).accessRequested)
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                        columnGap: "space.100",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                appearance: "default",
                                spacing: "compact",
                                onClick: onClick,
                                isLoading: requestAccessState === "loading",
                                testId: "sync-block-request-access-btn",
                                children: formatMessage((0, $fzXn1.syncBlockMessages).requestAccessButton)
                            }),
                            requestAccessState === "errored" && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text.warning",
                                testId: "sync-block-access-error-msg",
                                children: formatMessage((0, $fzXn1.syncBlockMessages).requestAccessError)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $ea1f07a46e6e26ea$export$f4d17ad2341a04f8 = ({ error: error, resourceId: resourceId })=>{
    const getErrorContent = ()=>{
        switch(error){
            case (0, $awHlv.SyncBlockError).Forbidden:
                if (resourceId) {
                    const { id: contentId } = (0, $fm19L.getPageIdAndTypeFromAri)(resourceId);
                    if (contentId) return /*#__PURE__*/ (0, $l998X.jsx)((0, $a081b56695b04c74$export$33325aff698460b9), {
                        contentId: contentId
                    });
                }
                return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    children: "Something went wrong"
                });
            case (0, $awHlv.SyncBlockError).NotFound:
                return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    children: "Sync Block Not Found"
                });
            case (0, $awHlv.SyncBlockError).Errored:
            default:
                return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    children: "Something went wrong"
                });
        }
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $e6n00.SyncBlockSharedCssClassName).error,
        children: getErrorContent()
    }));
};
module.exports["SyncedBlockErrorComponent"] = $ea1f07a46e6e26ea$export$f4d17ad2341a04f8;

});

parcelRegister("1Wy2j", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $ab0addd976e372f3$export$6d2e5b4986b73a9a = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        children: "Loading..."
    });
};
module.exports["SyncedBlockLoadingState"] = $ab0addd976e372f3$export$6d2e5b4986b73a9a;

});

parcelRegister("7VJPz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9ekTs = parcelRequire("9ekTs");

var $b7C1K = parcelRequire("b7C1K");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $au7xi = parcelRequire("au7xi");


var $jmjWc = parcelRequire("jmjWc");


const $16e92128cf9491a8$export$32d8d71ddecea49c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LmILK",
    name: "SmartButtonLoader",
    loader: async ()=>(await (parcelRequire("akQbd"))).SmartButton
});


const $cd53535796fd282e$export$16ffa5f7b88dc45f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId })=>{
    const extensionHandlers = {};
    extensionHandlers[0, $au7xi.smartButtonExtensionType] = (extension)=>{
        const pageAri = contentId ? (0, $9ekTs.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString() : undefined;
        const site = (0, $b7C1K.ConfluenceSiteAri).create({
            siteId: cloudId
        }).toString();
        const experienceName = (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            contentId: contentId ?? '',
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extension.extensionKey,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extension),
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $16e92128cf9491a8$export$32d8d71ddecea49c), {
            ruleId: extension.parameters?.ruleId,
            scopeId: extension.parameters?.scopeId,
            pageAri: pageAri,
            site: site,
            smartButtonName: extension.parameters?.smartButtonName,
            experienceTrackerName: experienceName,
            contentId: contentId ?? '',
            contentType: contentType ?? '',
            isViewMode: true
        }));
    };
    return extensionHandlers;
};
module.exports["getRendererSmartButtonExtensionHandlers"] = $cd53535796fd282e$export$16ffa5f7b88dc45f;

});

parcelRegister("au7xi", function(module, exports) {
const $ea41547e1b4f38b6$export$73185dbd06fc0dd8 = 'com.atlassian.automation.smart-button';
module.exports["smartButtonExtensionType"] = $ea41547e1b4f38b6$export$73185dbd06fc0dd8;

});

parcelRegister("akQbd", function(module, exports) {

let $78643f7c4ec02598$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $78643f7c4ec02598$var$load("6wr18"),
    $78643f7c4ec02598$var$load("gctwz"),
    $78643f7c4ec02598$var$load("hIZpb"),
    $78643f7c4ec02598$var$load("7f9Fz"),
    $78643f7c4ec02598$var$load("ffEVr"),
    $78643f7c4ec02598$var$load("lhkXg")
]).then(()=>parcelRequire('hLSQl'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("fgQGl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lpxTx = parcelRequire("lpxTx");

var $61vTv = parcelRequire("61vTv");


var $cLo2u = parcelRequire("cLo2u");


var $hp2SH = parcelRequire("hp2SH");


var $dPJCf = parcelRequire("dPJCf");


var $ep3mz = parcelRequire("ep3mz");

const $96596a053dd4ef1e$export$d1bbac313eb9a2c1 = ({ contentId: contentId, shouldRefetch: shouldRefetch, refetchImmediately: refetchImmediately, onRefetchComplete: onRefetchComplete })=>{
    const history = (0, $dPJCf.useHistory)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    (0, $42omo.useEffect)(()=>{
        let unlisten;
        if (shouldRefetch && contentId) {
            let chooseContentUnifiedQuery = (0, $61vTv.ContentUnifiedQuery);
            const queryVariable = {
                contentId: contentId,
                spaceKey: spaceKey,
                useNewContentTopper: true
            };
            if (contentType === 'blogpost') chooseContentUnifiedQuery = (0, $lpxTx.ContentBlogUnifiedQuery);
            const refetchFn = async ()=>{
                let versionNumber;
                try {
                    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
                    const queryResult = await (0, $hp2SH.getApolloClient)().query({
                        query: chooseContentUnifiedQuery,
                        context: {
                            single: true
                        },
                        fetchPolicy: 'network-only',
                        variables: queryVariable
                    });
                    // at this time, queryResult.data is always ContentUnifiedQueryType or ContentBlogUnifiedQueryType format
                    // @ts-ignore
                    versionNumber = queryResult.data.content?.nodes?.[0]?.version?.number;
                } catch (error) {
                // NOTE: We intentionally swallow any possible error here as this query is only aimed to
                // populate the cache with just published content. Should any error occur here after
                // successful publishing the page, the Apollo cache for the query will be invalidated
                // anyway and View Page will fetch the page and handle possible errors.
                }
                // If a callback is supplied, call it regardless
                onRefetchComplete && onRefetchComplete(versionNumber);
            };
            if (refetchImmediately) refetchFn();
            else unlisten = history?.listen(refetchFn);
        }
        return ()=>{
            // Call the unlistener when this component unmounts
            unlisten && unlisten();
        };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        shouldRefetch
    ]);
    return null;
};
module.exports["ContentRefetchHandler"] = $96596a053dd4ef1e$export$d1bbac313eb9a2c1;

});

parcelRegister("cNwLI", function(module, exports) {
const $b692efbc19ac9594$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $b692efbc19ac9594$export$df3c2062a081a534 = 'com.atlassian.confluence.spotlight';
const $b692efbc19ac9594$export$4454075c4322ae47 = 'com.atlassian.confluence.hub-section';
const $b692efbc19ac9594$export$2dd5fc71941a6787 = 'com.atlassian.confluence.knowledge-cards';
const $b692efbc19ac9594$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $b692efbc19ac9594$export$514105ca7c79025d = 'com.atlassian.confluence.carousel';
const $b692efbc19ac9594$export$cb2d1b0c753e69e6 = 'com.atlassian.confluence.company-hub-search';
const $b692efbc19ac9594$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $b692efbc19ac9594$export$8e1a1e8b8109dbf3 = '#DDDEE1';
const $b692efbc19ac9594$export$8161b1f4e2928fa0 = '--hub-primary-color';
const $b692efbc19ac9594$export$94d2a2331edd895d = '--hub-primary-text-color';
const $b692efbc19ac9594$export$6faa4a850bc4d0ce = 'https://db7d48b351f4e353b021f65a7a8d6928@o55978.ingest.us.sentry.io/4509310829920256';
const $b692efbc19ac9594$export$ea77880e3935182d = 'unknown';
module.exports["CARDS_EXTENSION_TYPE"] = $b692efbc19ac9594$export$81e5b59a1e176638;
module.exports["SPOTLIGHT_EXTENSION_TYPE"] = $b692efbc19ac9594$export$df3c2062a081a534;
module.exports["SECTION_EXTENSION_TYPE"] = $b692efbc19ac9594$export$4454075c4322ae47;
module.exports["RESOURCE_TILES_EXTENSION_TYPE"] = $b692efbc19ac9594$export$2dd5fc71941a6787;
module.exports["LINKS_MENU_EXTENSION_TYPE"] = $b692efbc19ac9594$export$9fdf64a495514b4;
module.exports["CAROUSEL_EXTENSION_TYPE"] = $b692efbc19ac9594$export$514105ca7c79025d;
module.exports["SEARCH_EXTENSION_TYPE"] = $b692efbc19ac9594$export$cb2d1b0c753e69e6;
module.exports["HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE"] = $b692efbc19ac9594$export$c14e692c91462ed4;
module.exports["DEFAULT_BRANDING_COLOR"] = $b692efbc19ac9594$export$8e1a1e8b8109dbf3;
module.exports["HUB_PRIMARY_COLOR_CSS_VAR"] = $b692efbc19ac9594$export$8161b1f4e2928fa0;
module.exports["HUB_PRIMARY_TEXT_COLOR_CSS_VAR"] = $b692efbc19ac9594$export$94d2a2331edd895d;

});

parcelRegister("kcoxM", function(module, exports) {
const $b61d5307562de512$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $b61d5307562de512$export$8a4891a61ff91b00 = 'cards';
const $b61d5307562de512$export$67bfcae6d68bb0bf = 'cardsExtension';
const $b61d5307562de512$export$7f17fab0aecb44ed = 'cardsExtensionConfig';
const $b61d5307562de512$export$6a35a50674becbae = 'cardsExtensionConfigBackgroundColor';
const $b61d5307562de512$export$9bf56665bf6ea6ed = 'cardsExtensionConfigBorderColor';
const $b61d5307562de512$export$cf23b6d2fd159502 = 'cardsExtensionConfigTextColor';
const $b61d5307562de512$export$131b76b4d30d2b44 = '2';
const $b61d5307562de512$export$a08b7507bedba276 = '3';
const $b61d5307562de512$export$c87753a8bb0c4e75 = '4';
const $b61d5307562de512$export$b84f9a7c097c895c = '5';
const $b61d5307562de512$export$5e905747d7497a1f = [
    {
        src: 'https://images.unsplash.com/photo-1571327352610-1c5484ccc840?auto=format&fit=crop&q=80&w=450',
        alt: 'closed wooden window'
    },
    {
        src: 'https://images.unsplash.com/photo-1566486106118-e1c24ad08802?auto=format&fit=crop&q=80&w=450',
        alt: 'green coconut trees'
    },
    {
        src: 'https://images.unsplash.com/photo-1602021224139-a6ba7e601732?auto=format&fit=crop&q=80&w=450',
        alt: 'white and black striped chair'
    },
    {
        src: 'https://images.unsplash.com/photo-1722259038071-6082eaf397ff?auto=format&fit=crop&q=80&w=450',
        alt: 'surfboard on top of a cement wall'
    },
    {
        src: 'https://images.unsplash.com/photo-1555001356-333dbc0f8b48?auto=format&fit=crop&q=80&w=450',
        alt: 'white stairs'
    },
    {
        src: 'https://images.unsplash.com/photo-1680258551363-6b5fd1ac2048?auto=format&fit=crop&q=80&w=450',
        alt: 'swimming pool tiles'
    }
];
module.exports["CARDS_EXTENSION_TYPE"] = $b61d5307562de512$export$81e5b59a1e176638;
module.exports["CARDS_EXTENSION_KEY"] = $b61d5307562de512$export$8a4891a61ff91b00;
module.exports["CARDS_EXTENSION_ANALYTIC_SOURCE"] = $b61d5307562de512$export$67bfcae6d68bb0bf;
module.exports["CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE"] = $b61d5307562de512$export$7f17fab0aecb44ed;
module.exports["CARDS_EXTENSION_CONFIG_BACKGROUND_ANALYTIC_SOURCE"] = $b61d5307562de512$export$6a35a50674becbae;
module.exports["CARDS_EXTENSION_CONFIG_BORDER_ANALYTIC_SOURCE"] = $b61d5307562de512$export$9bf56665bf6ea6ed;
module.exports["CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE"] = $b61d5307562de512$export$cf23b6d2fd159502;
module.exports["CARDS_EXTENSION_VERSION_2"] = $b61d5307562de512$export$131b76b4d30d2b44;
module.exports["CARDS_EXTENSION_VERSION_3"] = $b61d5307562de512$export$a08b7507bedba276;
module.exports["CARDS_EXTENSION_VERSION_4"] = $b61d5307562de512$export$c87753a8bb0c4e75;
module.exports["CARDS_EXTENSION_VERSION_5"] = $b61d5307562de512$export$b84f9a7c097c895c;
module.exports["CARDS_IMAGES_V5"] = $b61d5307562de512$export$5e905747d7497a1f;

});

parcelRegister("lf1vG", function(module, exports) {
const $5c1067f237374bc4$export$e03f5e560317f88a = '1';
const $5c1067f237374bc4$export$5e16975fb5214c6c = 'company-hub-search';
const $5c1067f237374bc4$export$cb2d1b0c753e69e6 = 'com.atlassian.confluence.company-hub-search';
const $5c1067f237374bc4$export$ec7b7d5be35b7dd3 = 'customSearchExtension';
module.exports["SEARCH_EXTENSION_VERSION_1"] = $5c1067f237374bc4$export$e03f5e560317f88a;
module.exports["SEARCH_EXTENSION_KEY"] = $5c1067f237374bc4$export$5e16975fb5214c6c;
module.exports["SEARCH_EXTENSION_TYPE"] = $5c1067f237374bc4$export$cb2d1b0c753e69e6;
module.exports["CUSTOM_SEARCH_EXTENSION_ANALYTIC_SOURCE"] = $5c1067f237374bc4$export$ec7b7d5be35b7dd3;

});

parcelRegister("cVaAA", function(module, exports) {
const $8fff034c75eb58ab$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $8fff034c75eb58ab$export$ed5854f17099adbf = 'linksMenuExtension';
module.exports["LINKS_MENU_EXTENSION_TYPE"] = $8fff034c75eb58ab$export$9fdf64a495514b4;
module.exports["LINKS_MENU_EXTENSION_ANALYTIC_SOURCE"] = $8fff034c75eb58ab$export$ed5854f17099adbf;

});

parcelRegister("5Ac5G", function(module, exports) {
const $df94cb31de3cc11e$export$a06ac4f1777262dc = 'com.atlassian.confluence.carousel';
const $df94cb31de3cc11e$export$6c8179fa243b4399 = 'carousel';
const $df94cb31de3cc11e$export$ca14f22a239c4ae9 = 'carouselExtension';
const $df94cb31de3cc11e$export$4cb671946a80c52e = 'carouselExtensionConfig';
const $df94cb31de3cc11e$export$93995a2609cff38d = 8;
const $df94cb31de3cc11e$export$3a86d0fc7eb402f4 = 'carousel-navigation-frame-';
const $df94cb31de3cc11e$export$9575b4f5d97a1c29 = '1';
const $df94cb31de3cc11e$export$b429752dfe934bea = '2';
const $df94cb31de3cc11e$export$c5c6e75ceae0cc22 = 10;
module.exports["carouselExtensionType"] = $df94cb31de3cc11e$export$a06ac4f1777262dc;
module.exports["carouselExtensionKey"] = $df94cb31de3cc11e$export$6c8179fa243b4399;
module.exports["carouselContentAnalyticSource"] = $df94cb31de3cc11e$export$ca14f22a239c4ae9;
module.exports["carouselConfigAnalyticSource"] = $df94cb31de3cc11e$export$4cb671946a80c52e;
module.exports["AUTOPLAY_SECONDS"] = $df94cb31de3cc11e$export$93995a2609cff38d;
module.exports["ARIA_CONTROLS_PREFIX"] = $df94cb31de3cc11e$export$3a86d0fc7eb402f4;
module.exports["CAROUSEL_VERSION_2"] = $df94cb31de3cc11e$export$b429752dfe934bea;
module.exports["FRAMES_LIMIT_V2"] = $df94cb31de3cc11e$export$c5c6e75ceae0cc22;

});

parcelRegister("bl1ay", function(module, exports) {
const $41fb1ea7d1d28d85$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $41fb1ea7d1d28d85$export$ca3a94184e0fbd97 = 'hub-element-placeholder';
module.exports["HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE"] = $41fb1ea7d1d28d85$export$c14e692c91462ed4;
module.exports["HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY"] = $41fb1ea7d1d28d85$export$ca3a94184e0fbd97;

});

parcelRegister("cbvYp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fOKpq = parcelRequire("fOKpq");


var $4IoVL = parcelRequire("4IoVL");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $1NBp8 = parcelRequire("1NBp8");


var $6M71K = parcelRequire("6M71K");


var $5kjCz = parcelRequire("5kjCz");


var $hUS75 = parcelRequire("hUS75");


var $4KFTW = parcelRequire("4KFTW");


var $bX5uj = parcelRequire("bX5uj");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $lOeVN = parcelRequire("lOeVN");


var $bAIqi = parcelRequire("bAIqi");


var $bflGB = parcelRequire("bflGB");



var $hl1Kw = parcelRequire("hl1Kw");


var $cEgMD = parcelRequire("cEgMD");


var $78QFu = parcelRequire("78QFu");


var $ep3mz = parcelRequire("ep3mz");


var $2YtTU = parcelRequire("2YtTU");





var $inPa6 = parcelRequire("inPa6");


var $k00oi = parcelRequire("k00oi");


var $5Gcps = parcelRequire("5Gcps");





var $7QM6o = parcelRequire("7QM6o");










const $4305591bcf0ed0e4$export$bd1b893a71ee8dab = (link)=>{
    const [analyticFields, setAnalyticFields] = (0, $42omo.useState)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const fetchData = async ()=>{
            const client = new (0, $k00oi.default)();
            try {
                const queriedMetadata = !!link && await client.fetchData(link);
                if (!queriedMetadata || !queriedMetadata.meta) return;
                const { containerId: initialContainerId, tenantId: initialTenantId, objectId: initialObjectId } = queriedMetadata.meta || {};
                if (!initialObjectId) return;
                const newObjectId = await (0, $5Gcps.getClickAndViewEventObjectIdFromLinkData)(initialObjectId, initialContainerId);
                setAnalyticFields({
                    containerId: initialContainerId,
                    tenantId: initialTenantId,
                    objectId: newObjectId
                });
            } catch (error) {
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).COMPANY_HUB
                });
                (0, $7Sm4c.markErrorAsHandled)(error);
            }
        };
        fetchData();
    }, [
        link
    ]);
    const { tenantId: tenantId, objectId: objectId } = analyticFields || {};
    const handleClick = ()=>{
        if (tenantId === cloudId) createAnalyticsEvent?.((0, $5Gcps.generateClickEventPayload)(activationId, cloudId, objectId, spaceId)).fire();
    };
    const handleView = ()=>{
        if (tenantId === cloudId) createAnalyticsEvent?.((0, $5Gcps.generateViewEventPayload)(activationId, cloudId, objectId, spaceId)).fire();
    };
    return {
        handleClick: analyticFields ? handleClick : undefined,
        handleView: analyticFields ? handleView : undefined
    };
};



var $biMIt = parcelRequire("biMIt");





var $xQxzY = parcelRequire("xQxzY");


var $eSUdr = parcelRequire("eSUdr");





var $1uFM6 = parcelRequire("1uFM6");




const $a453bfc5db2076e7$export$df3f3e4ed2d81d7 = ({ nextCursor: nextCursor, initialGroupIds: initialGroupIds })=>{
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Experimental Schema GraphQL Operation
    (0, $eSUdr.default)`query SegmentationTargetGroupsFieldGroupsQuery($after:String$first:Int=25){groups(after:$after first:$first){nodes{id name}pageInfo{endCursor hasNextPage}}}`, {
        variables: {
            after: nextCursor
        },
        skip: initialGroupIds.length === 0
    });
    let errorComponent = undefined;
    if (error && !loading) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else errorComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
    }
    return {
        data: data,
        loading: loading,
        errorComponent: errorComponent
    };
};


const $73ff39965b133879$var$useFeedbackCollectorWrapper = ({ source: source, type: type })=>{
    return (0, $lOeVN.useFeedbackCollector)({
        source: source,
        type: type
    });
};
const $73ff39965b133879$var$useSegmentationTargetGroupsWrapper = ({ nextCursor: nextCursor, initialGroupIds: initialGroupIds = [] })=>{
    return (0, $a453bfc5db2076e7$export$df3f3e4ed2d81d7)({
        nextCursor: nextCursor,
        initialGroupIds: initialGroupIds
    });
};
const $73ff39965b133879$var$ShortcutListenerWrapper = ({ accelerator: accelerator, listener: listener })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
        accelerator: accelerator,
        listener: listener
    });
};
const $73ff39965b133879$var$ExtensionConfigUpsellLoaderWrapper = ({ feature: feature })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bAIqi.ExtensionConfigUpsellLoader), {
        feature: feature
    });
};
const $73ff39965b133879$var$submitError = (error)=>{
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).COMPANY_HUB
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
};
const $73ff39965b133879$var$SmartCardProvider = ({ children: children })=>{
    return(// disable preview panel functionality for cards
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        isPreviewPanelAvailable: (_ari)=>false
    }, children));
};
const $73ff39965b133879$export$52286abe2bf4f236 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const start = (0, $42omo.useCallback)(({ analyticsSource: analyticsSource })=>{
        experienceTracker.start({
            name: (0, $irVI7.CARDS_IMAGE_UPLOAD_EXPERIENCE),
            attributes: {
                source: analyticsSource
            }
        });
    }, [
        experienceTracker
    ]);
    const succeed = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.CARDS_IMAGE_UPLOAD_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    const stopOnError = (0, $42omo.useCallback)(({ error: error })=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.CARDS_IMAGE_UPLOAD_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    return {
        start: start,
        succeed: succeed,
        stopOnError: stopOnError
    };
};
const $73ff39965b133879$export$50a2d523eb80eb6f = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const start = (0, $42omo.useCallback)(({ analyticsSource: analyticsSource, confluencePageId: confluencePageId })=>{
        experienceTracker.start({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE),
            attributes: {
                source: analyticsSource,
                contentId: confluencePageId
            }
        });
    }, [
        experienceTracker
    ]);
    const abort = (0, $42omo.useCallback)(({ reason: reason })=>{
        experienceTracker.abort({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE),
            reason: reason
        });
    }, [
        experienceTracker
    ]);
    const succeed = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    const stopOnError = (0, $42omo.useCallback)(({ error: error })=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    return {
        start: start,
        abort: abort,
        succeed: succeed,
        stopOnError: stopOnError
    };
};
const $73ff39965b133879$export$4bd687f80e42155a = (activeContentId, maybeCustomCoverImage)=>{
    if (maybeCustomCoverImage.indexOf('/') !== -1) {
        const temp = maybeCustomCoverImage.split('/');
        return [
            temp[0],
            temp[1]
        ];
    }
    // If it's not a stored cover image, we return original contentId & imageSrc
    return [
        activeContentId,
        maybeCustomCoverImage
    ];
};
const $73ff39965b133879$export$7f746b47c356effa = ({ contentId: contentId, imageSrc: imageSrc })=>{
    const [mediaConfig, setMediaConfig] = (0, $42omo.useState)(null);
    // When imageSrc is a stored cover image, it comes in format '{contentId}/{fileId}'
    // We need to split the string to get the collectionId and fileId
    const [collectionId, fileId] = $73ff39965b133879$export$4bd687f80e42155a(contentId, imageSrc);
    (0, $42omo.useEffect)(()=>{
        async function createMediaConfig() {
            if (!(0, $4IoVL.createRendererMediaProvider)) return;
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentId: collectionId,
                isExternalShare: false
            });
            if (!viewMediaClientConfig) {
                setMediaConfig(null);
                return;
            }
            setMediaConfig({
                collection: `contentId-${collectionId}`,
                authProvider: viewMediaClientConfig.authProvider,
                fileId: fileId
            });
        }
        createMediaConfig();
    }, [
        collectionId,
        fileId
    ]);
    return mediaConfig;
};
const $73ff39965b133879$export$9a7b37d3055a69a6 = ({ mode: mode, extensionNode: extensionNode, contentId: contentId = '', children: children })=>{
    const mediaUploadExperienceTracker = $73ff39965b133879$export$52286abe2bf4f236();
    const aiDescriptionExperienceTracker = $73ff39965b133879$export$50a2d523eb80eb6f();
    const sessionData = (0, $bQm3c.useSessionData)();
    const { cloudId: cloudId, displayName: displayName, isAdminHubAIEnabled: isAdminHubAIEnabled, orgId: orgId, userId: userId } = sessionData || {};
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isTargetAudience: isTargetAudience } = (0, $42omo.useContext)((0, $biMIt.AudienceSegmentationContext));
    const shouldShowPremiumUpsell = (0, $2YtTU.usePremiumGate)();
    const ConfigUpsellScreen = (0, $42omo.useMemo)(()=>shouldShowPremiumUpsell ? ({ feature: feature })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($73ff39965b133879$var$ExtensionConfigUpsellLoaderWrapper, {
                feature: feature
            }) : undefined, [
        shouldShowPremiumUpsell
    ]);
    const experienceStartComponent = (0, $42omo.useCallback)(()=>{
        if (!extensionNode) return null;
        const macroAttributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode);
        const experienceName = (0, $5kjCz.getExperienceName)(mode, extensionNode);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            attributes: macroAttributes,
            extensionKey: extensionNode.extensionKey,
            contentId: contentId,
            mode: mode,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        });
    }, [
        extensionNode,
        contentId,
        mode
    ]);
    const experienceSuccessComponent = (0, $42omo.useCallback)(()=>{
        if (!extensionNode) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: (0, $5kjCz.getExperienceName)(mode, extensionNode),
            contentId: contentId,
            extensionKey: extensionNode.extensionKey,
            mode: mode,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode)
        });
    }, [
        extensionNode,
        contentId,
        mode
    ]);
    const experienceStopComponent = (0, $42omo.useCallback)(({ error: error })=>{
        if (!extensionNode) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hUS75.MacroExperienceStop), {
            error: error,
            name: (0, $5kjCz.getExperienceName)(mode, extensionNode),
            contentId: contentId,
            extensionKey: extensionNode.extensionKey,
            mode: mode,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode)
        });
    }, [
        mode,
        extensionNode,
        contentId
    ]);
    const isSSRProductInDarkMode = (0, $42omo.useMemo)(()=>{
        return undefined;
    }, []);
    const errorBoundaryComponent = (0, $42omo.useMemo)(()=>({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).COMPANY_HUB
            }, children), []);
    const errorDisplayComponent = (0, $42omo.useMemo)(()=>({ error: error, childrenComponents: childrenComponents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }, childrenComponents), []);
    const useAnalyticsActions = (0, $42omo.useMemo)(()=>({
            useLinkAnalyticActions: $4305591bcf0ed0e4$export$bd1b893a71ee8dab
        }), []);
    const value = (0, $42omo.useMemo)(()=>({
            experienceStartComponent: experienceStartComponent,
            experienceSuccessComponent: experienceSuccessComponent,
            experienceStopComponent: experienceStopComponent,
            cloudId: cloudId,
            searchConfigProvider: {
                peopleDirectoryUrl: (0, $1NBp8.PEOPLE_DIRECTORY).toUrl(),
                advancedSearchUrl: (0, $1NBp8.ADVANCED_SEARCH).toUrl(),
                searchSessionId: searchSessionId || ''
            },
            displayName: displayName || '',
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            orgId: orgId || '',
            userId: userId || '',
            errorBoundaryComponent: errorBoundaryComponent,
            errorDisplayComponent: errorDisplayComponent,
            submitError: $73ff39965b133879$var$submitError,
            markErrorAsHandled: $7Sm4c.markErrorAsHandled,
            useMediaConfig: $73ff39965b133879$export$7f746b47c356effa,
            createEditorMediaProvider: $4IoVL.createEditorMediaProvider,
            mediaUploadExperienceTracker: mediaUploadExperienceTracker,
            aiDescriptionExperienceTracker: aiDescriptionExperienceTracker,
            useFeedbackCollector: $73ff39965b133879$var$useFeedbackCollectorWrapper,
            shortcutListener: $73ff39965b133879$var$ShortcutListenerWrapper,
            shouldShowPremiumUpsell: shouldShowPremiumUpsell,
            ConfigUpsellScreen: ConfigUpsellScreen,
            useSegmentationTargetGroups: $73ff39965b133879$var$useSegmentationTargetGroupsWrapper,
            isSSRProductInDarkMode: isSSRProductInDarkMode,
            analyticsContext: {
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            },
            useAnalyticsActions: useAnalyticsActions,
            isCompanyHub: (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey),
            isTargetAudience: isTargetAudience,
            smartCardProviderComponent: $73ff39965b133879$var$SmartCardProvider,
            showConfigPreambleSupportLink: true,
            enableTargeting: true,
            enableUnifiedSearchFeatures: true,
            enableSmartCardsFields: true
        }), [
        experienceSuccessComponent,
        experienceStopComponent,
        cloudId,
        displayName,
        isAdminHubAIEnabled,
        orgId,
        userId,
        searchSessionId,
        shouldShowPremiumUpsell,
        ConfigUpsellScreen,
        isSSRProductInDarkMode,
        errorBoundaryComponent,
        errorDisplayComponent,
        experienceStartComponent,
        mediaUploadExperienceTracker,
        aiDescriptionExperienceTracker,
        useAnalyticsActions,
        spaceKey,
        isTargetAudience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fOKpq.ProductDependenciesContext).Provider, {
        value: value
    }, children);
};
const $73ff39965b133879$export$443fd6903ad182a1 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($73ff39965b133879$export$9a7b37d3055a69a6, props, children);
module.exports["ConfluenceDependenciesProvider"] = $73ff39965b133879$export$443fd6903ad182a1;

});

parcelRegister("hUS75", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source) {
    if ((0, $6fil2.containsNetworkError)(error)) {
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).abort({
            name: name,
            reason: `Aborted ${name} because of network error: ${error.toString()}`,
            checkForTimeout: false,
            attributes: {
                ...attributes,
                source: source
            }
        });
        return;
    }
    (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
        name: name,
        error: error,
        attributes: {
            ...attributes,
            source: source
        }
    });
}
function $50ff55d614a641f6$export$d22b49804594ed4d({ attributes: attributes, children: children = null, error: error, contentId: contentId, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        if (error) $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source);
        else (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        error,
        mode,
        name,
        source
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStop"] = $50ff55d614a641f6$export$d22b49804594ed4d;

});

parcelRegister("bAIqi", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c1c72132c26b9ae6$export$349c99e57ed161b9 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "at4mJ",
    name: "ExtensionConfigUpsellLoader",
    loader: async ()=>(await (parcelRequire("jAGai"))).ExtensionConfigUpsell
});

const $c1c72132c26b9ae6$export$25389a114c9b393f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "rxN2C",
    name: "ExtensionInsertUpsellLoader",
    loader: async ()=>(await (parcelRequire("cfVLi"))).ExtensionInsertUpsell
});
module.exports["ExtensionConfigUpsellLoader"] = $c1c72132c26b9ae6$export$349c99e57ed161b9;
module.exports["ExtensionInsertUpsellLoader"] = $c1c72132c26b9ae6$export$25389a114c9b393f;

});

parcelRegister("jAGai", function(module, exports) {

let $e432163837388e6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e432163837388e6e$var$load("6XCf4"),
    $e432163837388e6e$var$load("5pvpJ"),
    $e432163837388e6e$var$load("1qlDN"),
    $e432163837388e6e$var$load("1yVM6"),
    $e432163837388e6e$var$load("9wTrW")
]).then(()=>parcelRequire('d1uaq'));

});

parcelRegister("cfVLi", function(module, exports) {

let $8ec3b10c7d66ca41$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ec3b10c7d66ca41$var$load("6XCf4"),
    $8ec3b10c7d66ca41$var$load("5pvpJ"),
    $8ec3b10c7d66ca41$var$load("1qlDN"),
    $8ec3b10c7d66ca41$var$load("1yVM6"),
    $8ec3b10c7d66ca41$var$load("5HTv6")
]).then(()=>parcelRequire('f4NfX'));

});

parcelRegister("2YtTU", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");

const $50d2dd6da149924b$export$31a131ac01af5546 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const canSkipEntitlementCheck = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query usePremiumGatePremiumGateQuery{entitlements{premiumExtensions{isEntitled}}}`, {
        skip: canSkipEntitlementCheck
    });
    if (error) {
        if (!((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMPANY_HUB
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !canSkipEntitlementCheck && !data?.entitlements.premiumExtensions.isEntitled;
};
module.exports["usePremiumGate"] = $50d2dd6da149924b$export$31a131ac01af5546;

});

parcelRegister("5Gcps", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $eSUdr = parcelRequire("eSUdr");

const $e798eb82c10075ec$export$10df301dbc20c6db = (0, $eSUdr.default)`query SpaceMetadataQuery($id:Long!){spaces(spaceId:$id){nodes{homepage{id}}}}`;


const $9f3924c176ad2a57$export$2dd23eaa621322c4 = (activationId, cloudId, objectId, spaceId)=>({
        type: 'sendTrackEvent',
        data: {
            action: 'viewed',
            actionSubject: 'companyHubLink',
            source: 'companyHub',
            objectType: 'page',
            objectId: objectId,
            attributes: {
                activationId: activationId,
                spaceId: spaceId,
                spaceType: 'system',
                pageType: 'page',
                cloudId: cloudId
            }
        }
    });
const $9f3924c176ad2a57$export$e25d369331b443dc = (activationId, cloudId, objectId, spaceId)=>({
        type: 'sendTrackEvent',
        data: {
            action: 'clicked',
            actionSubject: 'companyHubLink',
            source: 'companyHub',
            objectType: objectId ? 'page' : null,
            objectId: objectId,
            attributes: {
                activationId: activationId,
                spaceId: spaceId,
                spaceType: 'system',
                pageType: objectId ? 'page' : null,
                cloudId: cloudId
            }
        }
    });
const $9f3924c176ad2a57$export$95c55278d4aca494 = async (objectId, destinationContainerId)=>{
    if (destinationContainerId === objectId) {
        const client = (0, $hp2SH.getApolloClient)();
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: data } = await client.query({
            query: (0, $e798eb82c10075ec$export$10df301dbc20c6db),
            variables: {
                id: destinationContainerId
            }
        });
        const homepageId = data?.spaces?.nodes?.[0]?.homepage?.id;
        if (!homepageId) return;
        return homepageId;
    }
    return objectId;
};
module.exports["generateViewEventPayload"] = $9f3924c176ad2a57$export$2dd23eaa621322c4;
module.exports["generateClickEventPayload"] = $9f3924c176ad2a57$export$e25d369331b443dc;
module.exports["getClickAndViewEventObjectIdFromLinkData"] = $9f3924c176ad2a57$export$95c55278d4aca494;

});

parcelRegister("biMIt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $2z79p = parcelRequire("2z79p");

const $ab43be195aa7029f$export$f8421e3bf566787d = 'accessible-to-anyone';
const $ab43be195aa7029f$export$6fb8438eed1d64ed = /*#__PURE__*/ (0, $42omo.createContext)({
    isCompanyHub: false,
    currentAudienceGroupIds: [],
    setCurrentAudienceGroupIds: ()=>{},
    isTargetAudience: ()=>true,
    isSegmentationApplied: false,
    setIsSegmentationApplied: ()=>{}
});
const $ab43be195aa7029f$var$AudienceSegmentationContextProviderInternal = ({ children: children, isCompanyHub: isCompanyHub, initialAudienceGroupIds: initialAudienceGroupIds = [], initialSegmentationApplied: initialSegmentationApplied = false, shouldFetchUserGroups: shouldFetchUserGroups = false })=>{
    const [currentAudienceGroupIds, setCurrentAudienceGroupIds] = (0, $42omo.useState)(initialAudienceGroupIds);
    const [isSegmentationApplied, setIsSegmentationApplied] = (0, $42omo.useState)(initialSegmentationApplied);
    const isTargetAudience = (0, $42omo.useCallback)((targetGroupIds)=>{
        if (!isCompanyHub || // if we are outside of company hub, no filtering
        targetGroupIds === undefined // if no target groups are provided, no filtering
        ) return true;
        setIsSegmentationApplied(true);
        const audienceGroupIdsSet = new Set(currentAudienceGroupIds);
        if (audienceGroupIdsSet.has($ab43be195aa7029f$export$f8421e3bf566787d)) return false;
        return targetGroupIds?.some((allowedGroup)=>audienceGroupIdsSet.has(allowedGroup));
    }, [
        currentAudienceGroupIds,
        isCompanyHub
    ]);
    const audienceSegmentationContextValue = (0, $42omo.useMemo)(()=>({
            currentAudienceGroupIds: currentAudienceGroupIds,
            setCurrentAudienceGroupIds: setCurrentAudienceGroupIds,
            isCompanyHub: isCompanyHub,
            isTargetAudience: isTargetAudience,
            isSegmentationApplied: isSegmentationApplied,
            setIsSegmentationApplied: setIsSegmentationApplied
        }), [
        currentAudienceGroupIds,
        isCompanyHub,
        isTargetAudience,
        isSegmentationApplied
    ]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { error: queryError, loading: queryLoading } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $2z79p.AudienceSegmentationContextProviderQuery), {
        variables: {
            skip: !shouldFetchUserGroups || !isCompanyHub,
            accountId: userId
        },
        onCompleted: (data)=>{
            const userGroupIds = data?.user?.confluence?.groupsWithId?.map((result)=>result?.id).filter((id)=>!!id) ?? [];
            // onCompleted shouldn't be called if we skip the query but this is to ensure
            // the state doesn't get set when the fixture mock gives this query the default value
            shouldFetchUserGroups && setCurrentAudienceGroupIds(userGroupIds);
        }
    });
    const errorDisplay = (0, $42omo.useMemo)(()=>{
        if (queryError && !queryLoading) {
            if ((0, $1uFM6.isUnauthorizedError)(queryError)) (0, $7Sm4c.markErrorAsHandled)(queryError);
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: queryError
            });
        }
        return null;
    }, [
        queryError,
        queryLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab43be195aa7029f$export$6fb8438eed1d64ed.Provider, {
        value: audienceSegmentationContextValue
    }, errorDisplay, children);
};
const $ab43be195aa7029f$export$23b23ee9c5e80f4e = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMPANY_HUB
})($ab43be195aa7029f$var$AudienceSegmentationContextProviderInternal);
module.exports["COMMON_VIEW_ID"] = $ab43be195aa7029f$export$f8421e3bf566787d;
module.exports["AudienceSegmentationContext"] = $ab43be195aa7029f$export$6fb8438eed1d64ed;
module.exports["AudienceSegmentationContextProvider"] = $ab43be195aa7029f$export$23b23ee9c5e80f4e;

});

parcelRegister("hFplL", function(module, exports) {

let $cdc9ee01a884bfa1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cdc9ee01a884bfa1$var$load("7zr7w"),
    $cdc9ee01a884bfa1$var$load("7GmzD"),
    $cdc9ee01a884bfa1$var$load("ce3Ni"),
    $cdc9ee01a884bfa1$var$load("jtXXq"),
    $cdc9ee01a884bfa1$var$load("8JZKd"),
    $cdc9ee01a884bfa1$var$load("2YffH"),
    $cdc9ee01a884bfa1$var$load("f35QR"),
    $cdc9ee01a884bfa1$var$load("eVYW1"),
    $cdc9ee01a884bfa1$var$load("ls0Um"),
    $cdc9ee01a884bfa1$var$load("020xd"),
    $cdc9ee01a884bfa1$var$load("eTBsW"),
    $cdc9ee01a884bfa1$var$load("bYxCZ"),
    $cdc9ee01a884bfa1$var$load("6HBYC"),
    $cdc9ee01a884bfa1$var$load("eDqo1"),
    $cdc9ee01a884bfa1$var$load("1oiJ6"),
    $cdc9ee01a884bfa1$var$load("huUvS"),
    $cdc9ee01a884bfa1$var$load("eErVv"),
    $cdc9ee01a884bfa1$var$load("1Jgsw"),
    $cdc9ee01a884bfa1$var$load("98UJI"),
    $cdc9ee01a884bfa1$var$load("hwLGf"),
    $cdc9ee01a884bfa1$var$load("2B6wT"),
    $cdc9ee01a884bfa1$var$load("gKYwM"),
    $cdc9ee01a884bfa1$var$load("a5wu4"),
    $cdc9ee01a884bfa1$var$load("lPQcc"),
    $cdc9ee01a884bfa1$var$load("i0VYb"),
    $cdc9ee01a884bfa1$var$load("7f9Fz"),
    $cdc9ee01a884bfa1$var$load("9XYQ9"),
    $cdc9ee01a884bfa1$var$load("h4k4y"),
    $cdc9ee01a884bfa1$var$load("9ijrN"),
    $cdc9ee01a884bfa1$var$load("aeEUI"),
    $cdc9ee01a884bfa1$var$load("cwpgX"),
    $cdc9ee01a884bfa1$var$load("iXzmH"),
    $cdc9ee01a884bfa1$var$load("65c4i"),
    $cdc9ee01a884bfa1$var$load("cMlHc"),
    $cdc9ee01a884bfa1$var$load("lEurX"),
    $cdc9ee01a884bfa1$var$load("bTmOC"),
    $cdc9ee01a884bfa1$var$load("5EQhG"),
    $cdc9ee01a884bfa1$var$load("jYrum"),
    $cdc9ee01a884bfa1$var$load("7jSfd"),
    $cdc9ee01a884bfa1$var$load("4HZlX"),
    $cdc9ee01a884bfa1$var$load("kDqHr"),
    $cdc9ee01a884bfa1$var$load("6wr18"),
    $cdc9ee01a884bfa1$var$load("kjZZD"),
    $cdc9ee01a884bfa1$var$load("kWNlz"),
    $cdc9ee01a884bfa1$var$load("cHTTI"),
    $cdc9ee01a884bfa1$var$load("dTsOE"),
    $cdc9ee01a884bfa1$var$load("3gJkK"),
    $cdc9ee01a884bfa1$var$load("hhss7"),
    $cdc9ee01a884bfa1$var$load("7EorR"),
    $cdc9ee01a884bfa1$var$load("Wowvf"),
    $cdc9ee01a884bfa1$var$load("ffEVr"),
    $cdc9ee01a884bfa1$var$load("6Yu8N"),
    $cdc9ee01a884bfa1$var$load("6FB4U"),
    $cdc9ee01a884bfa1$var$load("aSHvy"),
    $cdc9ee01a884bfa1$var$load("fMsyQ")
]).then(()=>parcelRequire('kWs4M'));

});

parcelRegister("crH3b", function(module, exports) {

let $90f9669112715a81$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $90f9669112715a81$var$load("hwLGf"),
    $90f9669112715a81$var$load("7zr7w"),
    $90f9669112715a81$var$load("7GmzD"),
    $90f9669112715a81$var$load("kWNlz"),
    $90f9669112715a81$var$load("cHTTI"),
    $90f9669112715a81$var$load("ce3Ni"),
    $90f9669112715a81$var$load("jtXXq"),
    $90f9669112715a81$var$load("dChec"),
    $90f9669112715a81$var$load("2YffH"),
    $90f9669112715a81$var$load("f35QR"),
    $90f9669112715a81$var$load("eVYW1"),
    $90f9669112715a81$var$load("ls0Um"),
    $90f9669112715a81$var$load("020xd"),
    $90f9669112715a81$var$load("eTBsW"),
    $90f9669112715a81$var$load("bYxCZ"),
    $90f9669112715a81$var$load("6HBYC"),
    $90f9669112715a81$var$load("eDqo1"),
    $90f9669112715a81$var$load("1oiJ6"),
    $90f9669112715a81$var$load("huUvS"),
    $90f9669112715a81$var$load("3RdRc"),
    $90f9669112715a81$var$load("98UJI"),
    $90f9669112715a81$var$load("i0VYb"),
    $90f9669112715a81$var$load("7f9Fz"),
    $90f9669112715a81$var$load("9XYQ9"),
    $90f9669112715a81$var$load("h4k4y"),
    $90f9669112715a81$var$load("5EQhG"),
    $90f9669112715a81$var$load("jYrum"),
    $90f9669112715a81$var$load("7jSfd"),
    $90f9669112715a81$var$load("4HZlX"),
    $90f9669112715a81$var$load("kDqHr"),
    $90f9669112715a81$var$load("6wr18"),
    $90f9669112715a81$var$load("kjZZD"),
    $90f9669112715a81$var$load("dTsOE"),
    $90f9669112715a81$var$load("hhss7"),
    $90f9669112715a81$var$load("7EorR"),
    $90f9669112715a81$var$load("Wowvf"),
    $90f9669112715a81$var$load("ffEVr"),
    $90f9669112715a81$var$load("6Yu8N"),
    $90f9669112715a81$var$load("6FB4U"),
    $90f9669112715a81$var$load("aSHvy"),
    $90f9669112715a81$var$load("bTmOC"),
    $90f9669112715a81$var$load("lFZaH")
]).then(()=>parcelRequire('cBfKJ'));

});

parcelRegister("5N99w", function(module, exports) {

let $4378a0e164b04cd4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4378a0e164b04cd4$var$load("ce3Ni"),
    $4378a0e164b04cd4$var$load("jtXXq"),
    $4378a0e164b04cd4$var$load("8JZKd"),
    $4378a0e164b04cd4$var$load("eErVv"),
    $4378a0e164b04cd4$var$load("2Mq3f"),
    $4378a0e164b04cd4$var$load("lEurX"),
    $4378a0e164b04cd4$var$load("lPQcc"),
    $4378a0e164b04cd4$var$load("kjZZD"),
    $4378a0e164b04cd4$var$load("7f9Fz"),
    $4378a0e164b04cd4$var$load("9XYQ9"),
    $4378a0e164b04cd4$var$load("aeEUI"),
    $4378a0e164b04cd4$var$load("iXzmH"),
    $4378a0e164b04cd4$var$load("65c4i"),
    $4378a0e164b04cd4$var$load("7EorR"),
    $4378a0e164b04cd4$var$load("6wr18"),
    $4378a0e164b04cd4$var$load("cMlHc"),
    $4378a0e164b04cd4$var$load("hhss7"),
    $4378a0e164b04cd4$var$load("Wowvf"),
    $4378a0e164b04cd4$var$load("ffEVr"),
    $4378a0e164b04cd4$var$load("6Yu8N"),
    $4378a0e164b04cd4$var$load("6FB4U"),
    $4378a0e164b04cd4$var$load("aSHvy"),
    $4378a0e164b04cd4$var$load("kUykF")
]).then(()=>parcelRequire('27HWy'));

});

parcelRegister("9eTXW", function(module, exports) {

let $6ba0d580c77c844a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6ba0d580c77c844a$var$load("7zr7w"),
    $6ba0d580c77c844a$var$load("7GmzD"),
    $6ba0d580c77c844a$var$load("cwpgX"),
    $6ba0d580c77c844a$var$load("ce3Ni"),
    $6ba0d580c77c844a$var$load("jtXXq"),
    $6ba0d580c77c844a$var$load("2YffH"),
    $6ba0d580c77c844a$var$load("cgmWe"),
    $6ba0d580c77c844a$var$load("2Mq3f"),
    $6ba0d580c77c844a$var$load("2Gceu"),
    $6ba0d580c77c844a$var$load("i0VYb"),
    $6ba0d580c77c844a$var$load("7f9Fz"),
    $6ba0d580c77c844a$var$load("igTEs"),
    $6ba0d580c77c844a$var$load("9XYQ9"),
    $6ba0d580c77c844a$var$load("3kUQf"),
    $6ba0d580c77c844a$var$load("iFEfD"),
    $6ba0d580c77c844a$var$load("6wr18"),
    $6ba0d580c77c844a$var$load("kjZZD"),
    $6ba0d580c77c844a$var$load("hhss7"),
    $6ba0d580c77c844a$var$load("7EorR"),
    $6ba0d580c77c844a$var$load("Wowvf"),
    $6ba0d580c77c844a$var$load("ffEVr"),
    $6ba0d580c77c844a$var$load("6Yu8N"),
    $6ba0d580c77c844a$var$load("6FB4U"),
    $6ba0d580c77c844a$var$load("aSHvy"),
    $6ba0d580c77c844a$var$load("aUuEW")
]).then(()=>parcelRequire('aALia'));

});

parcelRegister("1Bhe3", function(module, exports) {

let $12a69bcd765749b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $12a69bcd765749b9$var$load("7zr7w"),
    $12a69bcd765749b9$var$load("7GmzD"),
    $12a69bcd765749b9$var$load("kWNlz"),
    $12a69bcd765749b9$var$load("cHTTI"),
    $12a69bcd765749b9$var$load("ce3Ni"),
    $12a69bcd765749b9$var$load("jtXXq"),
    $12a69bcd765749b9$var$load("2YffH"),
    $12a69bcd765749b9$var$load("f35QR"),
    $12a69bcd765749b9$var$load("eVYW1"),
    $12a69bcd765749b9$var$load("ls0Um"),
    $12a69bcd765749b9$var$load("020xd"),
    $12a69bcd765749b9$var$load("eTBsW"),
    $12a69bcd765749b9$var$load("bYxCZ"),
    $12a69bcd765749b9$var$load("6HBYC"),
    $12a69bcd765749b9$var$load("eDqo1"),
    $12a69bcd765749b9$var$load("lxiFd"),
    $12a69bcd765749b9$var$load("1oiJ6"),
    $12a69bcd765749b9$var$load("huUvS"),
    $12a69bcd765749b9$var$load("d9TJ0"),
    $12a69bcd765749b9$var$load("8nWJU"),
    $12a69bcd765749b9$var$load("kpq80"),
    $12a69bcd765749b9$var$load("98UJI"),
    $12a69bcd765749b9$var$load("2Mq3f"),
    $12a69bcd765749b9$var$load("hwLGf"),
    $12a69bcd765749b9$var$load("bTmOC"),
    $12a69bcd765749b9$var$load("a5wu4"),
    $12a69bcd765749b9$var$load("i0VYb"),
    $12a69bcd765749b9$var$load("7f9Fz"),
    $12a69bcd765749b9$var$load("5uN9h"),
    $12a69bcd765749b9$var$load("9XYQ9"),
    $12a69bcd765749b9$var$load("6aY84"),
    $12a69bcd765749b9$var$load("5CaYW"),
    $12a69bcd765749b9$var$load("h4k4y"),
    $12a69bcd765749b9$var$load("cwpgX"),
    $12a69bcd765749b9$var$load("5EQhG"),
    $12a69bcd765749b9$var$load("jYrum"),
    $12a69bcd765749b9$var$load("7jSfd"),
    $12a69bcd765749b9$var$load("4HZlX"),
    $12a69bcd765749b9$var$load("kDqHr"),
    $12a69bcd765749b9$var$load("6vhrJ"),
    $12a69bcd765749b9$var$load("6wr18"),
    $12a69bcd765749b9$var$load("kjZZD"),
    $12a69bcd765749b9$var$load("dTsOE"),
    $12a69bcd765749b9$var$load("hhss7"),
    $12a69bcd765749b9$var$load("7EorR"),
    $12a69bcd765749b9$var$load("Wowvf"),
    $12a69bcd765749b9$var$load("ffEVr"),
    $12a69bcd765749b9$var$load("6Yu8N"),
    $12a69bcd765749b9$var$load("6FB4U"),
    $12a69bcd765749b9$var$load("aSHvy"),
    $12a69bcd765749b9$var$load("dJOHz")
]).then(()=>parcelRequire('8Hi5s'));

});

parcelRegister("j5Mgj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $6mKj3 = parcelRequire("6mKj3");

const $7a372d7e7883072d$export$9143d6ac64592241 = ()=>{
    // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    return (0, $42omo.useMemo)(()=>({
            /**
			 * This feature flag has completed rollout in Confluence and is to be cleaned up from LD
			 * but cannot yet be cleaned up from editor component as pending rollout in other products first
			 */ 'lp-link-picker': true,
            'table-drag-and-drop': (0, $6mKj3.expVal)('platform_editor_tables_drag_and_drop', 'isEnabled', false),
            'table-with-fixed-column-widths-option': true,
            'renderer-tti-tracking': (0, $dh538.fg)('renderer_tti_tracking_confluence')
        }), []);
};
module.exports["useEditorFeatureFlags"] = $7a372d7e7883072d$export$9143d6ac64592241;

});

parcelRegister("brsfB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $9UKrO = parcelRequire("9UKrO");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");


var $4qzKl = parcelRequire("4qzKl");


var $jlIaF = parcelRequire("jlIaF");


var $5XsiK = parcelRequire("5XsiK");


var $eLV9q = parcelRequire("eLV9q");

function $ce8c9e4f9afe9f9c$export$14fbdf1c2aa5816c({ push: push, userId: userId, cloudId: cloudId, featureFlags: featureFlags }) {
    const intl = (0, $8C5kA.default)();
    const feedFollowData = (0, $4GlQ9.useFeedFollow)();
    const getNavigateToTeamsApp = (0, $eLV9q.useGetNavigateToTeamsApp)();
    const handleProfileCardActions = (0, $42omo.useCallback)((pushProfileCardActions, loggedInUserId)=>(profileCardUserId)=>{
            const atlassianPeopleProfileUrl = (0, $4qzKl.getAtlassianPeopleProfileUrl)(profileCardUserId, null, (0, $jlIaF.CONTEXT_PATH));
            const teamsAppPersonProfileUrl = getNavigateToTeamsApp({
                type: 'USER',
                payload: {
                    userId: profileCardUserId
                }
            }).href;
            const followed = !!(profileCardUserId && feedFollowData?.followedUsers?.includes(profileCardUserId));
            return [
                {
                    label: intl.formatMessage({
                        id: "view.profile"
                    }),
                    callback: (0, $5XsiK.isTeamsAppEnabled)() ? undefined : ()=>{
                        pushProfileCardActions((0, $4qzKl.getAtlassianPeopleProfileUrl)(profileCardUserId, null, (0, $jlIaF.CONTEXT_PATH)));
                    },
                    target: (0, $5XsiK.isTeamsAppEnabled)() ? '_blank' : undefined,
                    link: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : atlassianPeopleProfileUrl
                },
                {
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bedVD.FeedFollow), {
                        followed: followed
                    }),
                    id: 'feed-follow-user',
                    callback: feedFollowData.getToggleFollowUser(profileCardUserId, followed, 'editor'),
                    shouldRender: (userData)=>feedFollowData.renderFeedFollow && Boolean(profileCardUserId) && profileCardUserId !== loggedInUserId && userData?.status === 'active'
                }
            ];
        }, [
        feedFollowData,
        getNavigateToTeamsApp,
        intl
    ]);
    return (0, $42omo.useMemo)(()=>{
        return (0, $9UKrO.getProfileCardProvider)(cloudId, handleProfileCardActions(push, userId), featureFlags ?? {});
    }, [
        cloudId,
        handleProfileCardActions,
        push,
        userId,
        featureFlags
    ]);
}
module.exports["useProfilecardProvider"] = $ce8c9e4f9afe9f9c$export$14fbdf1c2aa5816c;

});

parcelRegister("9UKrO", function(module, exports) {

var $bumSD = parcelRequire("bumSD");

function $88671cc112964e63$export$ecc18d1a90c31bf8(cloudId, getActions, /**
	 * @deprecated This is no longer used we should remove in a future version
	 */ featureFlags) {
    return Promise.resolve({
        cloudId: cloudId,
        resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
        getActions: getActions
    });
}
module.exports["getProfileCardProvider"] = $88671cc112964e63$export$ecc18d1a90c31bf8;

});

parcelRegister("1SPMi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $3pfAb = parcelRequire("3pfAb");


var $bQm3c = parcelRequire("bQm3c");


var $2SowE = parcelRequire("2SowE");

const $c749b0358b0b3fb9$export$46da93e796378064 = (props)=>{
    const { objectId: objectId, objectType: objectType, children: children, source: source } = props;
    // setting default to development so in tests it doesn't fail due to being undefined
    const { environment: environment } = (0, $bQm3c.useSessionData)() || {};
    // setting default to development so in tests it doesn't fail due to being undefined
    const safeEnvironment = environment || 'DEVELOPMENT';
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        const instanceName = safeEnvironment;
        event.update((payload)=>{
            let newPayload = (0, $2SowE.extendPayloadAttributes)(payload, {
                objectId: objectId,
                objectType: objectType,
                rendererSource: source
            });
            if (instanceName) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                instance: instanceName
            });
            return newPayload;
        });
    }, [
        safeEnvironment,
        objectId,
        objectType,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: handleEvent,
        channel: (0, $3pfAb.FabricChannel).editor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: handleEvent,
        channel: (0, $3pfAb.FabricChannel).media
    }, children));
};
module.exports["RendererAnalyticsListener"] = $c749b0358b0b3fb9$export$46da93e796378064;

});

parcelRegister("3WO8q", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $eSUdr = parcelRequire("eSUdr");

const $b50b509b402b0702$export$89c600402d79f2bd = (0, $eSUdr.default)`mutation SetTaskStatusMutation($contentId:ID!$taskId:ID!$status:TaskStatus!){setTaskStatus(inlineTasksInput:{cid:$contentId taskId:$taskId status:$status trigger:VIEW_PAGE}){success}}`;



var $cgtv4 = parcelRequire("cgtv4");

const $c88a9f0357b47b1b$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    flagTitle: {
        id: "fabric-media-support.tasklist.error.flag.title",
        defaultMessage: "Something went wrong"
    },
    flagDescription: {
        id: "fabric-media-support.tasklist.error.flag.description",
        defaultMessage: "An error occurred while trying to change a task\u2019s status. Please try again later."
    }
});


class $cc5c5911f5458682$export$bfe822b045233127 {
    toggleTask(objectKey, state) {
        if (this._toggleTaskCallback) {
            this._toggleTaskCallback(objectKey, state);
            return Promise.resolve(state);
        } else /**
       * Using objectKey.objectAri may be a better alternative to passing in
       * contentId to the constructor. If it's reliable.
       */ // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        return (0, $hp2SH.getApolloClient)().mutate({
            mutation: (0, $b50b509b402b0702$export$89c600402d79f2bd),
            variables: {
                contentId: this.contentId,
                taskId: objectKey.localId,
                status: state === 'DONE' ? 'CHECKED' : 'UNCHECKED'
            }
        }).then((response)=>{
            const success = response?.data?.setTaskStatus?.success || false;
            if (!success) this.showErrorFlag();
            return state;
        }).catch(// this method is set to return `any` as a workaround for types.
        // Given that `TaskDecisionProvider.toggleTask` does not actually permit
        // `void` to be returned, what the `catch` block should probably be doing
        // is re-throwing the error that it got (at least that might match the
        // expectations). Since doing that will result in actual behavior changes
        // which I'm hesitant to perform, TS is simply silenced by `ny`-ing the
        // return type.
        (_)=>{
            /**
         * Note: there seems to be an issue whereby clicking a checkbox twice
         * quickly causes an error. I'm guessing something's not happy with a
         * mutation being issued while the previous one was still in-flight.
         * KTLO: we should probably create a queue as a workaround.
         * I'm (mdean2) not fixing this right now because I'm up against the
         * clock and the previous classic implementation suffered the same
         * problem.
         */ this.showErrorFlag();
        });
    }
    showErrorFlag() {
        this.flags.showErrorFlag({
            title: this.intl.formatMessage((0, $c88a9f0357b47b1b$export$a7357cdd1f0b0168).flagTitle),
            description: this.intl.formatMessage((0, $c88a9f0357b47b1b$export$a7357cdd1f0b0168).flagDescription)
        });
    }
    // Below are stubs, implemented to pacify TypeScript, and inherited from old
    // classic implementation.
    notifyRecentUpdates(_updateContext) {}
    subscribe(_objectKey, _handler) {}
    unsubscribe(_objectKey, _handler) {}
    unsubscribeRecentUpdates(_id) {}
    /* eslint-disable no-useless-constructor */ constructor(intl, flags, contentId, toggleTaskCallback){
        this.intl = intl;
        this.flags = flags;
        this.contentId = contentId;
        this.toggleTaskCallback = toggleTaskCallback;
        this._toggleTaskCallback = void 0;
        /**
     * eslint mistakenly thinks this is a useless constructor. It's not,
     * because TypeScript translates the 'public' arguments to actual code that
     * assigns them to instance variables.
     */ this._toggleTaskCallback = toggleTaskCallback;
    }
}
module.exports["ConfluenceTaskDecisionProvider"] = $cc5c5911f5458682$export$bfe822b045233127;

});

parcelRegister("gxhb8", function(module, exports) {
/* eslint-disable no-useless-constructor */ class $6c53b0825160fdb5$export$9a91b236871b318c {
    onFlush(callback) {
        if (!(callback instanceof Function)) throw new Error(`"onFlush" callback is supposed to be a function; saw ${typeof callback} instead`);
        this.onFlushCallback = callback;
    }
    /**
   * Forcefully flushes the batcher. Noop if current batch is empty.
   */ forceFlush() {
        // Currently force-flush is synchronous. Make sure the call sites are updated if
        // this is changed to a promise-based approach
        this.flush();
    }
    renewBatch() {
        const oldBatch = this.currentBatch;
        this.currentBatch = [];
        return oldBatch;
    }
    scheduleFlush() {
        if (!this.flushIntervalId) this.flushIntervalId = window.setInterval(this.flush, this.flushIntervalMs);
    }
    unscheduleFlush() {
        if (this.flushIntervalId) {
            window.clearInterval(this.flushIntervalId);
            this.flushIntervalId = undefined;
        }
    }
    constructor(flushIntervalMs){
        this.flushIntervalMs = flushIntervalMs;
        this.flushIntervalId = void 0;
        this.onFlushCallback = void 0;
        this.currentBatch = [];
        this.add = (item)=>{
            this.scheduleFlush();
            // If there's a previous task action for the same task, remove it
            this.currentBatch = this.currentBatch.filter((task)=>task.objectKey.localId !== item.objectKey.localId);
            this.currentBatch.push(item);
        };
        this.flush = ()=>{
            const batch = this.renewBatch();
            this.unscheduleFlush();
            if (batch.length === 0) return;
            try {
                if (this.onFlushCallback) this.onFlushCallback(batch);
            } catch (e) {
                // rethrow error asynchronously to allow other callbacks to execute
                setTimeout(()=>{
                    /* eslint-disable-next-line no-console */ console.error(`"onFlush" callback threw the below error. Please make sure your callbacks have proper error handling`);
                    throw e;
                }, 0);
            }
        };
    }
}
module.exports["TaskBatcher"] = $6c53b0825160fdb5$export$9a91b236871b318c;

});

parcelRegister("1h4jS", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $kDja4 = parcelRequire("kDja4");


var $eVXGa = parcelRequire("eVXGa");

const $d8d4bed41028565f$export$3b92560508ac384e = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardsEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    return {
        isEligibleCreateNewWhiteboard: edition !== (0, $euL71.ConfluenceEdition).FREE && isWhiteboardsEnabled && isAllowedToCreateWhiteboard
    };
};
module.exports["useIsEligibleCreateNewWhiteboard"] = $d8d4bed41028565f$export$3b92560508ac384e;

});

parcelRegister("ky6OW", function(module, exports) {
/* PromptPopup.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");

var $xQxzY = parcelRequire("xQxzY");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $1Whri = parcelRequire("1Whri");


var $3HOqx = parcelRequire("3HOqx");


var $9VJDA = parcelRequire("9VJDA");


var $7hXDW = parcelRequire("7hXDW");


var $inPa6 = parcelRequire("inPa6");


var $euL71 = parcelRequire("euL71");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $bMPhU = parcelRequire("bMPhU");


var $cLo2u = parcelRequire("cLo2u");


var $fhofE = parcelRequire("fhofE");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $dPJCf = parcelRequire("dPJCf");


var $7EIq6 = parcelRequire("7EIq6");




const $6357e9d0e6b873b0$var$WHITEBOARD_COMPETITORS = [
    {
        name: 'Miro',
        domains: [
            /miro\.com/i
        ]
    },
    {
        name: 'Mural',
        domains: [
            /mural\.co/i
        ]
    },
    {
        name: 'Lucid',
        domains: [
            /lucid\.co/i
        ]
    },
    {
        name: 'Microsoft Whiteboard',
        domains: [
            /whiteboard\.office\.com/i,
            /wbd\.ms/i
        ]
    },
    {
        name: 'Figjam',
        domains: [
            /figma\.com\/board/i
        ]
    },
    {
        name: 'Google Jamboard',
        domains: [
            /jamboard\.google\.com/i
        ]
    },
    {
        name: 'Excalidraw',
        domains: [
            /excalidraw\.com/i
        ]
    },
    {
        name: 'Klaxoon',
        domains: [
            /klaxoon\.com/i
        ]
    }
];
const $6357e9d0e6b873b0$export$ac6cace9ee376739 = (url)=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey ?? undefined);
    const competitor = $6357e9d0e6b873b0$var$WHITEBOARD_COMPETITORS.find((competitor)=>competitor.domains.some((regex)=>regex.test(url)));
    return {
        competitorName: isCreateWhiteboardEnabled ? competitor?.name : undefined
    };
};






var $3jwuS = parcelRequire("3jwuS");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");

const $b296c3c88c13c96d$export$c2b5ddd2c8b4a98c = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ mode: livePageMode }] = (0, $efvKr.useLivePageMode)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    return (0, $42omo.useMemo)(()=>{
        if (isLivePage) return {
            isLivePage: isLivePage,
            pageMode: livePageMode || 'view' // 'edit' or 'view' for live pages
        };
        else return {
            isLivePage: isLivePage,
            pageMode: isEditorPage ? 'edit' : 'view' // 'edit' or 'view' for classic pages
        };
    }, [
        isLivePage,
        livePageMode,
        isEditorPage
    ]);
};


const $e77af47ac217a90f$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    title: {
        id: "experiment-prompt-whiteboard-competitor-link.prompt-popup.title",
        defaultMessage: "Try Confluence whiteboards"
    },
    descriptionDefault: {
        id: "experiment-prompt-whiteboard-competitor-link.prompt-popup.description-default",
        defaultMessage: "We noticed you pasted a {competitorName} link. Reduce context switching by using a Confluence whiteboard instead."
    },
    descriptionImport: {
        id: "experiment-prompt-whiteboard-competitor-link.prompt-popup.description-import",
        defaultMessage: "We noticed you pasted a {competitorName} link. Reduce context switching by importing your work to a Confluence whiteboard instead."
    },
    createButtonDefault: {
        id: "experiment-prompt-whiteboard-competitor-link.prompt-popup.create-button-default",
        defaultMessage: "Create a whiteboard"
    },
    createButtonImport: {
        id: "experiment-prompt-whiteboard-competitor-link.prompt-popup.create-button-import",
        defaultMessage: "Import from {competitorName}"
    },
    dismissButton: {
        id: "experiment-prompt-whiteboard-competitor-link.prompt-popup.dismiss-button",
        defaultMessage: "Do not show again"
    }
});
const $e77af47ac217a90f$var$styles = {
    dismissPressable: "_bfhk1bhr _ca0qpxbi _n3tdpxbi _19bv1ejb _u5f31ejb",
    titleContainer: "_1e0c1txw _1bah1yb4 _4cvr1h6o",
    pressable: "_1yt41b66 _2rko12b0 _1bsb1tcg _4t3i1tcg",
    pressableClosed: "_bfhkp2ly _irr3kca2",
    pressableOpen: "_1a37fqqo _bfhkkca2 _1cwg1i6y",
    promptContainer: "_1e0c116y _4cvr1h6o _2hwxv77o _18u0v77o",
    popupBox: "_1bsb1gwv _ca0q12x7 _n3td12x7 _19bvutpp _u5f3utpp _19pkpxbi _otyrpxbi _18u01ejb _2hwx1ejb",
    popupDescription: "_19pku2gc _otyrpxbi",
    showMoreIcon: "_bfhksm61",
    ctaStyles: "_1yt4ze3t _18s8ze3t _4bfu1r31 _1hms8stv _ajmmnqa1 _11c82smr _syaz13af _bfhk1j28 _9oik1r31 _1bnxglyw _jf4cnqa1"
};
const $e77af47ac217a90f$var$CREATE_CONTENT_INLINE = (0, $eSUdr.gql)`
	mutation PromptPopupCreateContentInlineMutation($createdInContentId: ID!, $spaceKey: String) {
		createContentInline(
			input: { createdInContentId: $createdInContentId, spaceKey: $spaceKey, type: "whiteboard" }
		) {
			id
		}
	}
`;
const $e77af47ac217a90f$var$PAYWALL_CONTENT_TO_DISABLE = (0, $eSUdr.gql)`
	query PromptPopupPaywallContentToDisableQuery {
		paywallContentToDisable(contentType: "whiteboard") {
			deactivationIdentifier
			link
			title
		}
	}
`;
const $e77af47ac217a90f$var$PromptComponent = ({ competitorName: competitorName, linkType: linkType })=>{
    const intl = (0, $8C5kA.default)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const spaceKey = (0, $cLo2u.useSpaceKey)() || '';
    const homepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey) || '';
    const [isDismissOpen, setIsDismissOpen] = (0, $42omo.useState)(false);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const pageAnalyticsAttributes = (0, $b296c3c88c13c96d$export$c2b5ddd2c8b4a98c)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isImport = competitorName?.toLowerCase().includes('miro'); // currently only Miro supports importer
    const { data: paywallData, loading: paywallContentLoading } = (0, $xQxzY.useQuery)($e77af47ac217a90f$var$PAYWALL_CONTENT_TO_DISABLE, {
        skip: !isImport || edition === (0, $euL71.ConfluenceEdition).PREMIUM,
        fetchPolicy: 'no-cache'
    });
    const paywallContentToDisable = paywallData?.paywallContentToDisable;
    const displayImportCta = isImport && !paywallContentLoading && !(paywallContentToDisable?.deactivationIdentifier && paywallContentToDisable?.link && paywallContentToDisable?.title);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptPopup',
                source: 'competitorLink',
                attributes: {
                    linkContentType: 'whiteboard',
                    linkType: linkType,
                    ...pageAnalyticsAttributes
                },
                nonPrivacySafeAttributes: {
                    linkDomain: competitorName
                }
            }
        }).fire();
    }, [
        competitorName,
        createAnalyticsEvent,
        linkType,
        pageAnalyticsAttributes
    ]);
    const [createContentInline, { loading: createContentLoading }] = (0, $1KmJq.useMutation)($e77af47ac217a90f$var$CREATE_CONTENT_INLINE, {
        onCompleted: (data)=>{
            const contentId = data?.createContentInline?.id;
            if (!contentId) throw Error('no content id present');
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'createdByFlow',
                    actionSubject: 'content',
                    objectId: contentId,
                    objectType: 'whiteboard',
                    containerId: spaceKey,
                    containerType: 'space',
                    source: 'competitorLink',
                    attributes: {
                        flow: 'competitorLink',
                        contentType: 'whiteboard',
                        linkType: linkType,
                        isImport: displayImportCta ? 'true' : 'false',
                        ...pageAnalyticsAttributes
                    },
                    nonPrivacySafeAttributes: {
                        linkDomain: competitorName
                    }
                }
            }).fire();
            let url = (0, $fhofE.getFullWhiteboardUrl)(contentId, spaceKey);
            if (displayImportCta) url += url.includes('?') ? '&openMiroImportTool=true' : '?openMiroImportTool=true';
            push(url);
        }
    });
    const handleLinkClick = async ()=>{
        if (createContentLoading) return;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'clicked',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'createButton',
                source: 'competitorLink',
                attributes: {
                    linkContentType: 'whiteboard',
                    linkType: linkType,
                    isImport: displayImportCta ? 'true' : 'false',
                    ...pageAnalyticsAttributes
                },
                nonPrivacySafeAttributes: {
                    linkDomain: competitorName
                }
            }
        }).fire();
        await createContentInline({
            variables: {
                createdInContentId: homepageId,
                spaceKey: spaceKey
            }
        });
    };
    const descriptionText = intl.formatMessage(displayImportCta ? $e77af47ac217a90f$export$a7357cdd1f0b0168.descriptionImport : $e77af47ac217a90f$export$a7357cdd1f0b0168.descriptionDefault, {
        competitorName: competitorName
    });
    const createText = intl.formatMessage(displayImportCta ? $e77af47ac217a90f$export$a7357cdd1f0b0168.createButtonImport : $e77af47ac217a90f$export$a7357cdd1f0b0168.createButtonDefault, {
        competitorName: competitorName
    });
    const dismissText = intl.formatMessage($e77af47ac217a90f$export$a7357cdd1f0b0168.dismissButton);
    const handleDismissClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptDismiss',
                source: 'competitorLink',
                attributes: {
                    linkContentType: 'whiteboard',
                    linkType: linkType,
                    ...pageAnalyticsAttributes
                }
            }
        }).fire();
        setOnboardingState({
            key: (0, $dBcar.PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED).PROMPT_DISMISSED,
            value: 'true'
        });
        setIsDismissOpen(false);
    }, [
        createAnalyticsEvent,
        setOnboardingState,
        linkType,
        pageAnalyticsAttributes
    ]);
    const handleMoreMenuClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptMoreMenu',
                source: 'competitorLink',
                attributes: {
                    linkContentType: 'whiteboard',
                    linkType: linkType,
                    ...pageAnalyticsAttributes
                }
            }
        }).fire();
        setIsDismissOpen(!isDismissOpen);
    }, [
        createAnalyticsEvent,
        isDismissOpen,
        linkType,
        pageAnalyticsAttributes
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $e77af47ac217a90f$var$styles.popupBox,
        testId: "competitor-link-prompt-popup"
    }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $e77af47ac217a90f$var$styles.titleContainer
    }, /*#__PURE__*/ $42omo.createElement((0, $7hXDW.default), {
        size: "xsmall"
    }, intl.formatMessage($e77af47ac217a90f$export$a7357cdd1f0b0168.title)), /*#__PURE__*/ $42omo.createElement((0, $lGgRw.Popup), {
        shouldRenderToParent: false,
        isOpen: isDismissOpen,
        onClose: ()=>setIsDismissOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
                xcss: $e77af47ac217a90f$var$styles.dismissPressable,
                onClick: handleDismissClick,
                testId: "competitor-link-prompt-dismiss-button"
            }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, dismissText)),
        trigger: (triggerProps)=>/*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
                ...triggerProps,
                xcss: $e77af47ac217a90f$var$styles.showMoreIcon,
                onClick: handleMoreMenuClick,
                testId: "competitor-link-prompt-dismiss-menu"
            }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                label: dismissText,
                size: "medium"
            }))
    })), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $e77af47ac217a90f$var$styles.popupDescription
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, descriptionText)), /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        onClick: handleLinkClick,
        xcss: $e77af47ac217a90f$var$styles.ctaStyles
    }, createText));
};
const $e77af47ac217a90f$export$79356a2b3ed5a31d = ({ competitorName: competitorName, linkType: linkType })=>{
    const intl = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const pageAnalyticsAttributes = (0, $b296c3c88c13c96d$export$c2b5ddd2c8b4a98c)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptIcon',
                source: 'competitorLink',
                attributes: {
                    linkContentType: 'whiteboard',
                    linkType: linkType,
                    ...pageAnalyticsAttributes
                },
                nonPrivacySafeAttributes: {
                    linkDomain: competitorName
                }
            }
        }).fire();
    }, [
        competitorName,
        createAnalyticsEvent,
        linkType,
        pageAnalyticsAttributes
    ]);
    const handlePromptPopupClose = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'closed',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptPopup',
                source: 'competitorLink',
                attributes: {
                    linkContentType: 'whiteboard',
                    linkType: linkType,
                    ...pageAnalyticsAttributes
                }
            }
        }).fire();
        setIsOpen(false);
    }, [
        createAnalyticsEvent,
        linkType,
        pageAnalyticsAttributes
    ]);
    const handlePromptPopupClick = (0, $42omo.useCallback)(()=>{
        if (isOpen) handlePromptPopupClose();
        else {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'competitorLinkPrompt',
                    actionSubjectId: 'promptIcon',
                    source: 'competitorLink',
                    attributes: {
                        linkContentType: 'whiteboard',
                        linkType: linkType,
                        ...pageAnalyticsAttributes
                    }
                }
            }).fire();
            setIsOpen(!isOpen);
        }
    }, [
        createAnalyticsEvent,
        handlePromptPopupClose,
        isOpen,
        linkType,
        pageAnalyticsAttributes
    ]);
    return(// TODO: Add `shouldRenderToParent = true` to make popup experience accessible. See https://a11y.atlassian.net/browse/JCATS-788
    // shouldRenderToParent currently forced to false to prevent popup from being rendered in the wrong place
    /*#__PURE__*/ $42omo.createElement((0, $lGgRw.Popup), {
        shouldRenderToParent: false,
        isOpen: isOpen,
        onClose: handlePromptPopupClose,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ $42omo.createElement($e77af47ac217a90f$var$PromptComponent, {
                competitorName: competitorName,
                linkType: linkType
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
                ...triggerProps,
                onClick: handlePromptPopupClick,
                xcss: (0, $1Whri.cx)($e77af47ac217a90f$var$styles.pressable, isOpen ? $e77af47ac217a90f$var$styles.pressableOpen : $e77af47ac217a90f$var$styles.pressableClosed),
                testId: "competitor-link-prompt-icon"
            }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
                color: "var(--ds-icon-discovery, #AF59E1)",
                label: intl.formatMessage($e77af47ac217a90f$export$a7357cdd1f0b0168.title)
            }))
    }));
};
const $e77af47ac217a90f$export$342f0658478a7894 = ({ sourceUrl: sourceUrl, linkType: linkType })=>{
    const { data: onboardingStateData, loading: loading } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED).PROMPT_DISMISSED
    ]);
    const { isPromptDismissed: isPromptDismissed } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const { competitorName: competitorName } = (0, $6357e9d0e6b873b0$export$ac6cace9ee376739)(sourceUrl);
    const validLinkType = linkType && (linkType === 'inline' || linkType === 'card' || linkType === 'embed') ? linkType : undefined;
    return !loading && !isPromptDismissed && competitorName && (0, $6mKj3.expValEquals)('prompt_whiteboard_competitor_link', 'cohort', 'experiment') ? /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $e77af47ac217a90f$var$styles.promptContainer
    }, /*#__PURE__*/ $42omo.createElement($e77af47ac217a90f$export$79356a2b3ed5a31d, {
        competitorName: competitorName,
        linkType: validLinkType
    })) : null;
};
module.exports["PromptPopupContainer"] = $e77af47ac217a90f$export$342f0658478a7894;

});

parcelRegister("fhofE", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $db55d2db1b1085cb$var$BASE_URL_META_SELECTOR = "meta[name='confluence-base-url']";
const $db55d2db1b1085cb$var$getBaseUrlForLocalhost = ()=>{
    const baseUrlFromMeta = window.document.querySelector($db55d2db1b1085cb$var$BASE_URL_META_SELECTOR)?.getAttribute('content') ?? 'https://hello.atlassian.net/wiki';
    return baseUrlFromMeta.substring(0, baseUrlFromMeta.length - 5);
};
const $db55d2db1b1085cb$export$f654b28f82155665 = ()=>{
    if (typeof window.location === 'undefined') return '';
    const baseUrl = window.location.origin;
    // If we are in localhost, we use the base URL from the meta tag
    if (new URL(baseUrl).hostname === 'localhost') return $db55d2db1b1085cb$var$getBaseUrlForLocalhost();
    return baseUrl;
};
const $db55d2db1b1085cb$export$420f191ed44b660f = (contentId, spaceKey)=>`${$db55d2db1b1085cb$export$f654b28f82155665()}${(0, $1NBp8.WHITEBOARD_BOARD).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    })}`;
module.exports["getFullWhiteboardUrl"] = $db55d2db1b1085cb$export$420f191ed44b660f;

});

parcelRegister("dWvqY", function(module, exports) {

var $isUvp = parcelRequire("isUvp");

const $a26913502fd09079$var$getRect = (element)=>{
    const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = element;
    return {
        width: offsetWidth,
        height: offsetHeight
    };
};
const $a26913502fd09079$export$76974b428a49f15b = (index)=>index;
const $a26913502fd09079$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $a26913502fd09079$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler($a26913502fd09079$var$getRect(element));
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const run = ()=>{
            const entry = entries[0];
            if (entry == null ? void 0 : entry.borderBoxSize) {
                const box = entry.borderBoxSize[0];
                if (box) {
                    handler({
                        width: box.inlineSize,
                        height: box.blockSize
                    });
                    return;
                }
            }
            handler($a26913502fd09079$var$getRect(element));
        };
        instance.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $a26913502fd09079$var$addEventListenerOptions = {
    passive: true
};
const $a26913502fd09079$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $a26913502fd09079$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $a26913502fd09079$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $a26913502fd09079$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = instance.options.useScrollendEvent && $a26913502fd09079$var$supportsScrollend ? ()=>void 0 : (0, $isUvp.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $a26913502fd09079$var$addEventListenerOptions);
    const registerScrollendEvent = instance.options.useScrollendEvent && $a26913502fd09079$var$supportsScrollend;
    if (registerScrollendEvent) element.addEventListener("scrollend", endHandler, $a26913502fd09079$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        if (registerScrollendEvent) element.removeEventListener("scrollend", endHandler);
    };
};
const $a26913502fd09079$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = instance.options.useScrollendEvent && $a26913502fd09079$var$supportsScrollend ? ()=>void 0 : (0, $isUvp.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $a26913502fd09079$var$addEventListenerOptions);
    const registerScrollendEvent = instance.options.useScrollendEvent && $a26913502fd09079$var$supportsScrollend;
    if (registerScrollendEvent) element.addEventListener("scrollend", endHandler, $a26913502fd09079$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        if (registerScrollendEvent) element.removeEventListener("scrollend", endHandler);
    };
};
const $a26913502fd09079$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return element[instance.options.horizontal ? "offsetWidth" : "offsetHeight"];
};
const $a26913502fd09079$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $a26913502fd09079$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $a26913502fd09079$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        const run = ()=>{
                            this._measureElement(entry.target, entry);
                        };
                        this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $a26913502fd09079$export$76974b428a49f15b,
                rangeExtractor: $a26913502fd09079$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $a26913502fd09079$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                useScrollendEvent: false,
                useAnimationFrameWithResizeObserver: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $isUvp.memo)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $isUvp.memo)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $isUvp.memo)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $isUvp.memo)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset(),
                this.options.lanes
            ], (measurements, outerSize, scrollOffset, lanes)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $a26913502fd09079$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset,
                lanes: lanes
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualIndexes = (0, $isUvp.memo)(()=>{
            let startIndex = null;
            let endIndex = null;
            const range = this.calculateRange();
            if (range) {
                startIndex = range.startIndex;
                endIndex = range.endIndex;
            }
            this.maybeNotify.updateDeps([
                this.isScrolling,
                startIndex,
                endIndex
            ]);
            return [
                this.options.rangeExtractor,
                this.options.overscan,
                this.options.count,
                startIndex,
                endIndex
            ];
        }, (rangeExtractor, overscan, count, startIndex, endIndex)=>{
            return startIndex === null || endIndex === null ? [] : rangeExtractor({
                startIndex: startIndex,
                endIndex: endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $isUvp.memo)(()=>[
                this.getVirtualIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $isUvp.notUndefined)(measurements[$a26913502fd09079$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $isUvp.notUndefined)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align, itemSize = 0)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") align = toOffset >= scrollOffset + size ? "end" : "start";
            if (align === "center") toOffset += (itemSize - size) / 2;
            else if (align === "end") toOffset -= size;
            const maxOffset = this.getTotalSize() + this.options.scrollMargin - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align, item.size),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            index = Math.max(0, Math.min(index, this.options.count - 1));
            let attempts = 0;
            const maxAttempts = 10;
            const tryScroll = (currentAlign)=>{
                if (!this.targetWindow) return;
                const offsetInfo = this.getOffsetForIndex(index, currentAlign);
                if (!offsetInfo) {
                    console.warn("Failed to get offset for index:", index);
                    return;
                }
                const [offset, align] = offsetInfo;
                this._scrollToOffset(offset, {
                    adjustments: void 0,
                    behavior: behavior
                });
                this.targetWindow.requestAnimationFrame(()=>{
                    const currentOffset = this.getScrollOffset();
                    const afterInfo = this.getOffsetForIndex(index, align);
                    if (!afterInfo) {
                        console.warn("Failed to get offset for index:", index);
                        return;
                    }
                    if (!(0, $isUvp.approxEqual)(afterInfo[0], currentOffset)) scheduleRetry(align);
                });
            };
            const scheduleRetry = (align)=>{
                if (!this.targetWindow) return;
                attempts++;
                if (attempts < maxAttempts) this.targetWindow.requestAnimationFrame(()=>tryScroll(align));
                else console.warn(`Failed to scroll to index ${index} after ${maxAttempts} attempts.`);
            };
            tryScroll(initialAlign);
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else if (this.options.lanes === 1) end = ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0;
            else {
                const endByLane = Array(this.options.lanes).fill(null);
                let endIndex = measurements.length - 1;
                while(endIndex >= 0 && endByLane.some((val)=>val === null)){
                    const item = measurements[endIndex];
                    if (endByLane[item.lane] === null) endByLane[item.lane] = item.end;
                    endIndex--;
                }
                end = Math.max(...endByLane.filter((val)=>val !== null));
            }
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $a26913502fd09079$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $a26913502fd09079$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset, lanes: lanes }) {
    const lastIndex = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    if (measurements.length <= lanes) return {
        startIndex: 0,
        endIndex: lastIndex
    };
    let startIndex = $a26913502fd09079$var$findNearestBinarySearch(0, lastIndex, getOffset, scrollOffset);
    let endIndex = startIndex;
    if (lanes === 1) while(endIndex < lastIndex && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    else if (lanes > 1) {
        const endPerLane = Array(lanes).fill(0);
        while(endIndex < lastIndex && endPerLane.some((pos)=>pos < scrollOffset + outerSize)){
            const item = measurements[endIndex];
            endPerLane[item.lane] = item.end;
            endIndex++;
        }
        const startPerLane = Array(lanes).fill(scrollOffset + outerSize);
        while(startIndex >= 0 && startPerLane.some((pos)=>pos >= scrollOffset)){
            const item = measurements[startIndex];
            startPerLane[item.lane] = item.start;
            startIndex--;
        }
        startIndex = Math.max(0, startIndex - startIndex % lanes);
        endIndex = Math.min(lastIndex, endIndex + (lanes - 1 - endIndex % lanes));
    }
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}
module.exports["defaultRangeExtractor"] = $a26913502fd09079$export$7eb7cb13fd21e5e1;
module.exports["observeElementRect"] = $a26913502fd09079$export$5a50ff2cde8c3802;
module.exports["observeWindowRect"] = $a26913502fd09079$export$e911b82c7a99311;
module.exports["observeElementOffset"] = $a26913502fd09079$export$fbc040aee017375a;
module.exports["observeWindowOffset"] = $a26913502fd09079$export$518998f8c5d09287;
module.exports["windowScroll"] = $a26913502fd09079$export$2162c5b3eeedd27;
module.exports["elementScroll"] = $a26913502fd09079$export$1cdb988e5ab69fe7;
module.exports["Virtualizer"] = $a26913502fd09079$export$89be5a243e59c4b2;

});

parcelRegister("edEsl", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ 
var $eGqQQ = parcelRequire("eGqQQ");

const $027ba4852fb11225$var$requests = new Map();
const $027ba4852fb11225$var$setCacheWithTimeout = (fileId, req)=>$027ba4852fb11225$var$requests.set(fileId, req) && void setTimeout(()=>$027ba4852fb11225$var$requests.delete(fileId), 3000);
const $027ba4852fb11225$var$globalMediaViewedListener = (options)=>{
    // To avoid case when user opens media-picker (and we don't want to call BE API after that)
    if (!options.isUserCollection) {
        // Sometimes globalEventMediaEmitter will invoke the globalMediaViewedListener callback
        // multiple times for a single `media-viewed` event. For this reason we return a cached
        // request promise if one exists
        const priorRequestForTheSameFileID = $027ba4852fb11225$var$requests.get(options?.fileId);
        return priorRequestForTheSameFileID || (()=>{
            const mediaViewedReq = fetch('/wiki/rest/internal/1.0/eventnotifier/notify', {
                method: 'POST',
                body: JSON.stringify({
                    attachmentViewed: {
                        fileStoreId: options.fileId
                    }
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            $027ba4852fb11225$var$setCacheWithTimeout(options.fileId, mediaViewedReq);
            return mediaViewedReq;
        })();
    }
};
let $027ba4852fb11225$var$mediaViewedListenerRegistered = false;
const $027ba4852fb11225$export$dbbc14ed63c88dd4 = ()=>{
    if (!$027ba4852fb11225$var$mediaViewedListenerRegistered) {
        (0, $eGqQQ.globalMediaEventEmitter).on('media-viewed', $027ba4852fb11225$var$globalMediaViewedListener);
        $027ba4852fb11225$var$mediaViewedListenerRegistered = true;
    }
};
const $027ba4852fb11225$export$29046bd16724fad9 = ()=>{
    (0, $eGqQQ.globalMediaEventEmitter).off('media-viewed', $027ba4852fb11225$var$globalMediaViewedListener);
    $027ba4852fb11225$var$mediaViewedListenerRegistered = false;
};
module.exports["registerGlobalMediaViewedListener"] = $027ba4852fb11225$export$dbbc14ed63c88dd4;
module.exports["removeGlobalMediaViewedListener"] = $027ba4852fb11225$export$29046bd16724fad9;

});

parcelRegister("eXfot", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $408d997ca1cff4e4$export$2fe8e9e635ca9d7a = (0, $eSUdr.default)`mutation SetBatchedTaskStatus($contentId:ID!$tasks:[InlineTask]!$trigger:PageUpdateTrigger=VIEW_PAGE){setBatchedTaskStatus(batchedInlineTasksInput:{contentId:$contentId tasks:$tasks trigger:$trigger}){success}}`;
module.exports["SetBatchedTaskStatusMutation"] = $408d997ca1cff4e4$export$2fe8e9e635ca9d7a;

});

parcelRegister("isUvp", function(module, exports) {
function $d716ac5cbe209b77$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    function memoizedFunction() {
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    }
    memoizedFunction.updateDeps = (newDeps)=>{
        deps = newDeps;
    };
    return memoizedFunction;
}
function $d716ac5cbe209b77$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $d716ac5cbe209b77$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1.01;
const $d716ac5cbe209b77$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};
module.exports["memo"] = $d716ac5cbe209b77$export$7c73462e0d25e514;
module.exports["notUndefined"] = $d716ac5cbe209b77$export$9a1adf421b69c6a;
module.exports["approxEqual"] = $d716ac5cbe209b77$export$8a4f1dcc58a69dbd;
module.exports["debounce"] = $d716ac5cbe209b77$export$61fc7d43ac8f84b0;

});


$parcel$global.rlb("jQBh0")
//# sourceMappingURL=FullPageEditorComponent.226d37a7.js.map
